import * as i0 from '@angular/core';
import { Component, Input, Injectable, EventEmitter, Output, InjectionToken, Pipe, Inject, forwardRef, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap';
import { ModalDismissReasons, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as i2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1$1 from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import * as i1$2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1$3 from '@angular/common/http';
import { HttpParams, HttpErrorResponse } from '@angular/common/http';
import { map as map$1 } from 'rxjs/operators';
import * as i1$4 from 'ngx-clipboard';
import { ClipboardModule } from 'ngx-clipboard';
import { BrowserModule } from '@angular/platform-browser';

class AccordionChevronComponent {
    constructor(ngbPanel) {
        this.ngbPanel = ngbPanel;
    }
    get open() {
        return this.ngbPanel.isOpen;
    }
}
AccordionChevronComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AccordionChevronComponent, deps: [{ token: i1.NgbPanel }], target: i0.ɵɵFactoryTarget.Component });
AccordionChevronComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: AccordionChevronComponent, selector: "app-accordion-chevron", inputs: { id: "id" }, ngImport: i0, template: `<span [id]="id" 
                   style="font-size: large" 
                   class="fa" 
                   [class.fa-angle-down]="open" 
                   [class.fa-angle-right]="!open"></span>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AccordionChevronComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-accordion-chevron',
                    template: `<span [id]="id" 
                   style="font-size: large" 
                   class="fa" 
                   [class.fa-angle-down]="open" 
                   [class.fa-angle-right]="!open"></span>`
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbPanel }]; }, propDecorators: { id: [{
                type: Input
            }] } });

class AjaxLoadingIndicatorComponent {
}
AjaxLoadingIndicatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AjaxLoadingIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AjaxLoadingIndicatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: AjaxLoadingIndicatorComponent, selector: "app-ajax-loading-indicator", ngImport: i0, template: "<style type='text/css'>@-webkit-keyframes uil-default-anim {\n                         0% {\n                           opacity: 1\n                         }\n                         100% {\n                           opacity: 0\n                         }\n                       }\n\n@keyframes uil-default-anim {\n  0% {\n    opacity: 1\n  }\n  100% {\n    opacity: 0\n  }\n}\n\n.uil-default-css > div:nth-of-type(1) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.5s;\n  animation-delay: -0.5s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(2) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.4166666666666667s;\n  animation-delay: -0.4166666666666667s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(3) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.33333333333333337s;\n  animation-delay: -0.33333333333333337s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(4) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.25s;\n  animation-delay: -0.25s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(5) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.16666666666666669s;\n  animation-delay: -0.16666666666666669s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(6) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.08333333333333331s;\n  animation-delay: -0.08333333333333331s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(7) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(8) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.08333333333333337s;\n  animation-delay: 0.08333333333333337s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(9) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.16666666666666663s;\n  animation-delay: 0.16666666666666663s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(10) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.25s;\n  animation-delay: 0.25s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(11) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.33333333333333337s;\n  animation-delay: 0.33333333333333337s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(12) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.41666666666666663s;\n  animation-delay: 0.41666666666666663s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n</style>\n\n<div class='uil-default-css' style='-webkit-transform:scale(1)'>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(0deg) translate(0,-60px);transform:rotate(0deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(30deg) translate(0,-60px);transform:rotate(30deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(60deg) translate(0,-60px);transform:rotate(60deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(90deg) translate(0,-60px);transform:rotate(90deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(120deg) translate(0,-60px);transform:rotate(120deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(150deg) translate(0,-60px);transform:rotate(150deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(180deg) translate(0,-60px);transform:rotate(180deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(210deg) translate(0,-60px);transform:rotate(210deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(240deg) translate(0,-60px);transform:rotate(240deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(270deg) translate(0,-60px);transform:rotate(270deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(300deg) translate(0,-60px);transform:rotate(300deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n  <div\n    style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(330deg) translate(0,-60px);transform:rotate(330deg) translate(0,-60px);border-radius:10px;position:absolute;'></div>\n</div>\n", styles: ["@-webkit-keyframes uil-default-anim {\n                         0% {\n                           opacity: 1\n                         }\n                         100% {\n                           opacity: 0\n                         }\n                       }\n\n@keyframes uil-default-anim {\n  0% {\n    opacity: 1\n  }\n  100% {\n    opacity: 0\n  }\n}\n\n.uil-default-css > div:nth-of-type(1) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.5s;\n  animation-delay: -0.5s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(2) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.4166666666666667s;\n  animation-delay: -0.4166666666666667s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(3) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.33333333333333337s;\n  animation-delay: -0.33333333333333337s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(4) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.25s;\n  animation-delay: -0.25s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(5) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.16666666666666669s;\n  animation-delay: -0.16666666666666669s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(6) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: -0.08333333333333331s;\n  animation-delay: -0.08333333333333331s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(7) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(8) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.08333333333333337s;\n  animation-delay: 0.08333333333333337s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(9) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.16666666666666663s;\n  animation-delay: 0.16666666666666663s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(10) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.25s;\n  animation-delay: 0.25s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(11) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.33333333333333337s;\n  animation-delay: 0.33333333333333337s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n\n.uil-default-css > div:nth-of-type(12) {\n  -webkit-animation: uil-default-anim 1s linear infinite;\n  animation: uil-default-anim 1s linear infinite;\n  -webkit-animation-delay: 0.41666666666666663s;\n  animation-delay: 0.41666666666666663s;\n}\n\n.uil-default-css {\n  position: relative;\n  background: none;\n  width: 200px;\n  height: 200px;\n}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AjaxLoadingIndicatorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-ajax-loading-indicator',
                    templateUrl: './ajax-loading-indicator.component.html'
                }]
        }] });

const image = '../assets/ajax-loading-indicator-small.gif';
class AjaxLoadingIndicatorSmallComponent {
    constructor() {
        this.src = image;
    }
}
AjaxLoadingIndicatorSmallComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AjaxLoadingIndicatorSmallComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AjaxLoadingIndicatorSmallComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: AjaxLoadingIndicatorSmallComponent, selector: "app-ajax-loading-indicator-small", ngImport: i0, template: `<img [src]="src" />`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AjaxLoadingIndicatorSmallComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-ajax-loading-indicator-small',
                    template: `<img [src]="src" />`
                }]
        }] });

class AlertModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open(title) {
        const modalRef = this.modalService.open(AlertModalComponent, { size: 'sm', backdrop: 'static', keyboard: false });
        const instance = modalRef.componentInstance;
        instance.title = title;
        return instance;
    }
    openWithMessageAndTitle(title, message) {
        const modalRef = this.modalService.open(AlertModalComponent, { size: 'sm', backdrop: 'static', keyboard: false });
        const instance = modalRef.componentInstance;
        instance.title = title;
        instance.message = message;
        return instance;
    }
    openWithMessageAndTitleAndShowOkButtonAndReturnPromise(title, message) {
        const modalRef = this.modalService.open(AlertModalComponent, { size: 'sm', backdrop: 'static', keyboard: false });
        const instance = modalRef.componentInstance;
        instance.title = title;
        instance.message = message;
        instance.showOkButton = true;
        return modalRef.result;
    }
}
AlertModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AlertModalService, deps: [{ token: i1.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
AlertModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AlertModalService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AlertModalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.NgbModal }]; } });
class AlertModalComponent {
    constructor(modal) {
        this.modal = modal;
        this.showOkButton = false;
        this.enableClosingActions = true;
    }
    get linkTitleText() {
        return this.linkTitle ? this.linkTitle : this.link;
    }
    cancel() {
        this.modal.dismiss('cancel');
    }
    confirm() {
        this.modal.close();
    }
    close() {
        this.modal.close();
    }
}
AlertModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AlertModalComponent, deps: [{ token: i1.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component });
AlertModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: AlertModalComponent, selector: "app-alert-modal", inputs: { title: "title", message: "message", link: "link", linkTitle: "linkTitle", showOkButton: "showOkButton", enableClosingActions: "enableClosingActions" }, ngImport: i0, template: `
    <div class="modal-header modal-header-warning">
      <h4 class="modal-title">
        <span translate>{{title}}</span>
      </h4>
      <h4 class="modal-title">
        <a style="float: top" *ngIf="enableClosingActions"><i id="close_alert_modal_link" class="fa fa-times" (click)="cancel()"></i></a>
      </h4>
    </div>
    <div class="modal-body">
      <app-ajax-loading-indicator *ngIf="message === undefined"></app-ajax-loading-indicator>
      <span *ngIf="message !== undefined">{{message}}</span>
      <a id="alert_modal_link" *ngIf="link" rel="noopener noreferrer" [href]="link" target="_blank">{{linkTitleText}}</a>
    </div>
    <div class="modal-footer" *ngIf="showOkButton && enableClosingActions">
      <button id="confirm_alert_modal_button" type="button" class="btn btn-secondary-action confirm" (click)="cancel()">OK</button>
    </div>
  `, isInline: true, components: [{ type: AjaxLoadingIndicatorComponent, selector: "app-ajax-loading-indicator" }], directives: [{ type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: AlertModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-alert-modal',
                    styleUrls: [],
                    template: `
    <div class="modal-header modal-header-warning">
      <h4 class="modal-title">
        <span translate>{{title}}</span>
      </h4>
      <h4 class="modal-title">
        <a style="float: top" *ngIf="enableClosingActions"><i id="close_alert_modal_link" class="fa fa-times" (click)="cancel()"></i></a>
      </h4>
    </div>
    <div class="modal-body">
      <app-ajax-loading-indicator *ngIf="message === undefined"></app-ajax-loading-indicator>
      <span *ngIf="message !== undefined">{{message}}</span>
      <a id="alert_modal_link" *ngIf="link" rel="noopener noreferrer" [href]="link" target="_blank">{{linkTitleText}}</a>
    </div>
    <div class="modal-footer" *ngIf="showOkButton && enableClosingActions">
      <button id="confirm_alert_modal_button" type="button" class="btn btn-secondary-action confirm" (click)="cancel()">OK</button>
    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbActiveModal }]; }, propDecorators: { title: [{
                type: Input
            }], message: [{
                type: Input
            }], link: [{
                type: Input
            }], linkTitle: [{
                type: Input
            }], showOkButton: [{
                type: Input
            }], enableClosingActions: [{
                type: Input
            }] } });

class BackButtonComponent {
    constructor() {
        this.back = new EventEmitter();
    }
}
BackButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: BackButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BackButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: BackButtonComponent, selector: "app-back-button", inputs: { id: "id" }, outputs: { back: "back" }, ngImport: i0, template: `
    <div class="row">
      <div class="col-12">
        <a [id]="id" (click)="this.back.next()"></a>
      </div>
    </div>
  `, isInline: true, styles: ["@charset \"UTF-8\";a{border-radius:15px;color:#a5acb0!important;background:transparent;border:none;font-size:25pt;cursor:pointer;padding:0}a:before{font-family:simple-line-icons;content:\"\uE07A\"}"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: BackButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-back-button',
                    styleUrls: ['./back-button.scss'],
                    template: `
    <div class="row">
      <div class="col-12">
        <a [id]="id" (click)="this.back.next()"></a>
      </div>
    </div>
  `
                }]
        }], propDecorators: { id: [{
                type: Input
            }], back: [{
                type: Output
            }] } });

function referenceEquality$1(lhs, rhs) {
    return lhs === rhs;
}
function areEqual(lhs, rhs, equals = referenceEquality$1) {
    if ((isDefined(lhs) && !isDefined(rhs)) || (!isDefined(lhs) && isDefined(rhs))) {
        return false;
    }
    else if (!isDefined(lhs) && !isDefined(rhs)) {
        return true;
    }
    else {
        return equals(lhs, rhs);
    }
}
function isDefined(obj) {
    return obj !== null && obj !== undefined;
}
function requireDefined(obj, msg) {
    if (!isDefined(obj)) {
        throw new Error('Object must not be null or undefined: ' + msg);
    }
    return obj;
}
function mapOptional(obj, fn) {
    if (isDefined(obj)) {
        return fn(obj);
    }
    else {
        return null;
    }
}
function assertNever(_x, msg) {
    throw new Error(msg);
}
function identity(obj) {
    return obj;
}
function valuesExcludingKeys(obj, exclude) {
    const result = [];
    for (const entry of Object.entries(obj)) {
        if (!exclude.has(entry[0])) {
            result.push(entry[1]);
        }
    }
    return result;
}
function stringMapToObject(map) {
    const result = {};
    map.forEach((value, key) => result[key] = value);
    return result;
}
function numberMapToObject(map) {
    const result = {};
    map.forEach((value, key) => result[key] = value);
    return result;
}
function isString(str) {
    return typeof str === 'string';
}
function isNumber(str) {
    return typeof str === 'number';
}
function isBoolean(str) {
    return typeof str === 'boolean';
}
function hasValue(obj) {
    for (const value of Object.values(obj)) {
        if (!!value) {
            return true;
        }
    }
    return false;
}

var object = /*#__PURE__*/Object.freeze({
    __proto__: null,
    areEqual: areEqual,
    isDefined: isDefined,
    requireDefined: requireDefined,
    mapOptional: mapOptional,
    assertNever: assertNever,
    identity: identity,
    valuesExcludingKeys: valuesExcludingKeys,
    stringMapToObject: stringMapToObject,
    numberMapToObject: numberMapToObject,
    isString: isString,
    isNumber: isNumber,
    isBoolean: isBoolean,
    hasValue: hasValue
});

const LOCALIZER = new InjectionToken('localizer');
class TranslateValuePipe {
    constructor(localizer) {
        this.localizer = localizer;
    }
    transform(value, useUILanguage = false, useThisSpecificLanguage) {
        this.cleanSubscription();
        if (useThisSpecificLanguage) {
            this.localization = this.localizer.translateToGivenLanguage(value, useThisSpecificLanguage);
            this.languageSubscription = this.localizer.translateLanguage$.subscribe(() => {
                this.localization = this.localizer.translateToGivenLanguage(value, useThisSpecificLanguage);
            });
        }
        else {
            this.localization = this.localizer.translate(value, useUILanguage);
            this.languageSubscription = this.localizer.translateLanguage$.subscribe(() => {
                this.localization = this.localizer.translate(value, useUILanguage);
            });
        }
        return this.localization;
    }
    cleanSubscription() {
        if (isDefined(this.languageSubscription)) {
            this.languageSubscription.unsubscribe();
        }
    }
    ngOnDestroy() {
        this.cleanSubscription();
    }
}
TranslateValuePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: TranslateValuePipe, deps: [{ token: LOCALIZER }], target: i0.ɵɵFactoryTarget.Pipe });
TranslateValuePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: TranslateValuePipe, name: "translateValue", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: TranslateValuePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'translateValue',
                    pure: false
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALIZER]
                }] }]; } });

class BreadcrumbComponent {
    constructor(router) {
        this.router = router;
    }
    refresh($event, target) {
        if (this.refreshPath) {
            this.router.navigate(this.refreshPath, { skipLocationChange: true }).then(() => this.router.navigate(target, { skipLocationChange: true }));
            $event.preventDefault();
        }
    }
}
BreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: BreadcrumbComponent, deps: [{ token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Component });
BreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: BreadcrumbComponent, selector: "app-breadcrumb", inputs: { location: "location", linkActive: "linkActive", refreshPath: "refreshPath" }, ngImport: i0, template: `
    <ol class="breadcrumb">
      <li class="breadcrumb-item" [class.active]="active" *ngFor="let breadcrumb of (location | async); let active = last; let i = index">
        <!-- Normal ancestor link -->
        <a [id]=" i + '_breadcrumb_link'" *ngIf="!active && breadcrumb.route" [routerLink]="breadcrumb.route">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </a>
        <!-- Non-linked active view indicator (or anything without route) -->
        <span *ngIf="(active && !linkActive) || !breadcrumb.route">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </span>
        <!-- Active view refresh link using full page load (i.e., standard html link, skip routing) -->
        <a [id]=" i + '_breadcrumb_link'" *ngIf="active && linkActive && !refreshPath && breadcrumb.route" [href]="breadcrumb.route!.join('/')">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </a>
        <!-- Active view refresh link using transitional route target -->
        <a [id]=" i + '_breadcrumb_link'" *ngIf="active && linkActive && refreshPath && breadcrumb.route" [href]="breadcrumb.route!.join('/')" (click)="refresh($event, breadcrumb.route)">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </a>
      </li>
    </ol>
  `, isInline: true, styles: [".breadcrumb{border:none;font-size:10px;font-weight:400;margin-bottom:0}"], directives: [{ type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "async": i1$1.AsyncPipe, "translate": i2.TranslatePipe, "translateValue": TranslateValuePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-breadcrumb',
                    styleUrls: ['./breadcrumb.component.scss'],
                    template: `
    <ol class="breadcrumb">
      <li class="breadcrumb-item" [class.active]="active" *ngFor="let breadcrumb of (location | async); let active = last; let i = index">
        <!-- Normal ancestor link -->
        <a [id]=" i + '_breadcrumb_link'" *ngIf="!active && breadcrumb.route" [routerLink]="breadcrumb.route">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </a>
        <!-- Non-linked active view indicator (or anything without route) -->
        <span *ngIf="(active && !linkActive) || !breadcrumb.route">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </span>
        <!-- Active view refresh link using full page load (i.e., standard html link, skip routing) -->
        <a [id]=" i + '_breadcrumb_link'" *ngIf="active && linkActive && !refreshPath && breadcrumb.route" [href]="breadcrumb.route!.join('/')">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </a>
        <!-- Active view refresh link using transitional route target -->
        <a [id]=" i + '_breadcrumb_link'" *ngIf="active && linkActive && refreshPath && breadcrumb.route" [href]="breadcrumb.route!.join('/')" (click)="refresh($event, breadcrumb.route)">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </a>
      </li>
    </ol>
  `
                }]
        }], ctorParameters: function () { return [{ type: i1$2.Router }]; }, propDecorators: { location: [{
                type: Input
            }], linkActive: [{
                type: Input
            }], refreshPath: [{
                type: Input
            }] } });

class ConfirmationModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open(title, bodyTranslateParams, ...bodyParagraphs) {
        const modalRef = this.modalService.open(ConfirmationModalComponent, { size: 'sm' });
        const instance = modalRef.componentInstance;
        instance.title = title;
        instance.bodyParagraphs = bodyParagraphs;
        instance.bodyTranslateParams = bodyTranslateParams;
        return modalRef.result;
    }
    openWithNonTranslatableContentAlsoPresent(title, nonTranslatableBodyParagraphs, bodyTranslateParams, ...bodyParagraphs) {
        const modalRef = this.modalService.open(ConfirmationModalComponent, { size: 'sm' });
        const instance = modalRef.componentInstance;
        instance.title = title;
        instance.bodyParagraphs = bodyParagraphs;
        instance.bodyTranslateParams = undefined;
        instance.nonTranslatableBodyParagraphs = nonTranslatableBodyParagraphs;
        return modalRef.result;
    }
    openEditInProgress() {
        return this.open('Edit in progress', undefined, 'Are you sure that you want to continue? By continuing unsaved changes will be lost.');
    }
    openModalClose() {
        return this.open('Modals are open', undefined, 'Are you sure that you want to continue? By continuing all modals will be closed.');
    }
}
ConfirmationModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ConfirmationModalService, deps: [{ token: i1.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
ConfirmationModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ConfirmationModalService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ConfirmationModalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.NgbModal }]; } });
class ConfirmationModalComponent {
    constructor(modal) {
        this.modal = modal;
    }
    cancel() {
        this.modal.dismiss('cancel');
    }
    confirm() {
        this.modal.close();
    }
}
ConfirmationModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ConfirmationModalComponent, deps: [{ token: i1.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component });
ConfirmationModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: ConfirmationModalComponent, selector: "app-confirmation-modal", inputs: { title: "title", bodyParagraphs: "bodyParagraphs", bodyTranslateParams: "bodyTranslateParams", nonTranslatableBodyParagraphs: "nonTranslatableBodyParagraphs" }, ngImport: i0, template: `
    <div class="modal-header modal-header-warning">
      <h4 class="modal-title">
        <a><i id="close_confirmation_modal_link" class="fa fa-times" (click)="cancel()"></i></a>
        <span translate>{{title}}</span>
      </h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12" *ngIf="bodyParagraphs">
          <p *ngFor="let paragraph of bodyParagraphs" translate [translateParams]="bodyTranslateParams">{{paragraph }}</p>
        </div>
        <div class="col-md-12" *ngIf="nonTranslatableBodyParagraphs">
          <p *ngFor="let paragraph of nonTranslatableBodyParagraphs">{{paragraph }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="confirm_confirmation_modal_button" type="button" class="btn btn-secondary-action confirm" (click)="confirm()" translate>Yes</button>
      <button id="cancel_confirmation_modal_button" type="button" class="btn btn-link cancel" (click)="cancel()" translate>Cancel</button>
    </div>
  `, isInline: true, styles: [""], directives: [{ type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ConfirmationModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-confirmation-modal',
                    styleUrls: ['./confirmation-modal.component.scss'],
                    template: `
    <div class="modal-header modal-header-warning">
      <h4 class="modal-title">
        <a><i id="close_confirmation_modal_link" class="fa fa-times" (click)="cancel()"></i></a>
        <span translate>{{title}}</span>
      </h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12" *ngIf="bodyParagraphs">
          <p *ngFor="let paragraph of bodyParagraphs" translate [translateParams]="bodyTranslateParams">{{paragraph }}</p>
        </div>
        <div class="col-md-12" *ngIf="nonTranslatableBodyParagraphs">
          <p *ngFor="let paragraph of nonTranslatableBodyParagraphs">{{paragraph }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="confirm_confirmation_modal_button" type="button" class="btn btn-secondary-action confirm" (click)="confirm()" translate>Yes</button>
      <button id="cancel_confirmation_modal_button" type="button" class="btn btn-link cancel" (click)="cancel()" translate>Cancel</button>
    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbActiveModal }]; }, propDecorators: { title: [{
                type: Input
            }], bodyParagraphs: [{
                type: Input
            }], bodyTranslateParams: [{
                type: Input
            }], nonTranslatableBodyParagraphs: [{
                type: Input
            }] } });

function limit(arr, amount) {
    return arr.slice(0, Math.min(amount, arr.length));
}
function filterDefined(arr) {
    const result = [];
    for (const item of arr) {
        if (isDefined(item)) {
            result.push(item);
        }
    }
    return result;
}
function normalizeAsArray(obj) {
    return Array.isArray(obj) ? obj : isDefined(obj) ? [obj] : [];
}
function collectProperties(items, propertyExtractor) {
    const result = new Set();
    for (const item of items) {
        if (Array.isArray(item)) {
            for (const innerItem of item) {
                result.add(propertyExtractor(innerItem));
            }
        }
        else {
            result.add(propertyExtractor(item));
        }
    }
    return result;
}
function index(items, indexExtractor) {
    const result = new Map();
    for (const item of items) {
        result.set(indexExtractor(item), item);
    }
    return result;
}
function moveElement(array, fromIndex, toIndex, indexChangedCb) {
    if (fromIndex >= array.length || fromIndex < 0) {
        throw new Error('From index out of bounds: ' + fromIndex);
    }
    if (toIndex >= array.length || toIndex < 0) {
        throw new Error('Index2 out of bounds: ' + toIndex);
    }
    const value = array.splice(fromIndex, 1);
    array.splice(toIndex, 0, value[0]);
    if (indexChangedCb) {
        indexChangedCb(array[toIndex], toIndex);
        if (fromIndex < toIndex) {
            for (let i = fromIndex; i < toIndex; i++) {
                indexChangedCb(array[i], i);
            }
        }
        else if (fromIndex > toIndex) {
            for (let i = toIndex + 1; i <= fromIndex; i++) {
                indexChangedCb(array[i], i);
            }
        }
    }
}
function swapElements(array, index1, index2, indexChangedCb) {
    if (index1 >= array.length || index1 < 0) {
        throw new Error('Index1 out of bounds: ' + index1);
    }
    if (index2 >= array.length || index1 < 0) {
        throw new Error('Index2 out of bounds: ' + index1);
    }
    const temp = array[index1];
    array[index1] = array[index2];
    array[index2] = temp;
    if (indexChangedCb) {
        indexChangedCb(array[index1], index1);
        indexChangedCb(array[index2], index2);
    }
}
function resetWith(array, toResetWith) {
    array.splice(0, array.length);
    for (const item of toResetWith) {
        array.push(item);
    }
}
function referenceEquality(lhs, rhs) {
    return lhs === rhs;
}
function anyMatching(arr, predicate) {
    for (const item of arr) {
        if (predicate(item)) {
            return true;
        }
    }
    return false;
}
function allMatching(arr, predicate) {
    for (const item of arr) {
        if (!predicate(item)) {
            return false;
        }
    }
    return true;
}
function firstMatching(arr, predicate) {
    for (const item of arr) {
        if (predicate(item)) {
            return item;
        }
    }
    return null;
}
function contains(arr, value, equals = referenceEquality) {
    return anyMatching(arr, (item) => equals(item, value));
}
function containsAny(arr, values, equals = referenceEquality) {
    return anyMatching(values, (value) => contains(arr, value, equals));
}
function containsAll(arr, values, equals = referenceEquality) {
    return allMatching(values, (value) => contains(arr, value, equals));
}
function arraysAreEqual(lhs, rhs, equals = referenceEquality) {
    return containsAll(lhs, rhs, equals) && containsAll(rhs, lhs, equals);
}
function firstMatchingValue(arr, values, equals = referenceEquality) {
    return firstMatching(arr, item => contains(values, item, equals));
}
// return true if removed
function removeMatching(arr, predicate) {
    const matchingIndices = [];
    for (let i = arr.length - 1; i >= 0; i--) {
        const item = arr[i];
        if (predicate(item)) {
            matchingIndices.push(i);
        }
    }
    for (const i of matchingIndices) {
        arr.splice(i, 1);
    }
    return matchingIndices.length > 0;
}
// returns true is replaced
function replaceMatching(arr, predicate, replaceWith) {
    for (let i = 0; i < arr.length; i++) {
        if (predicate(arr[i])) {
            arr[i] = replaceWith;
            return true;
        }
    }
    return false;
}
function keepMatching(arr, predicate) {
    removeMatching(arr, item => !predicate(item));
}
function remove(arr, item) {
    removeMatching(arr, i => i === item);
}
function flatten(arr) {
    const result = [];
    for (const innerArr of arr) {
        for (const item of innerArr) {
            result.push(item);
        }
    }
    return result;
}
function groupBy(arr, indexByExtractor) {
    const result = new Map();
    function createOrGet(indexProperty) {
        const resultList = result.get(indexProperty);
        if (resultList) {
            return resultList;
        }
        else {
            const newResultList = [];
            result.set(indexProperty, newResultList);
            return newResultList;
        }
    }
    for (const item of arr) {
        createOrGet(indexByExtractor(item)).push(item);
    }
    return result;
}
function requireSingle(arr) {
    if (arr.length !== 1) {
        throw new Error('Single element required, was: ' + arr.length);
    }
    return arr[0];
}
function insertBefore(arr, item, ref) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === ref) {
            arr.splice(i, 0, item);
            return;
        }
    }
    throw new Error('Reference item not in array');
}
function first(arr) {
    if (arr.length === 0) {
        throw new Error('Cannot get first since array is empty');
    }
    return arr[0];
}
function last(arr) {
    if (arr.length === 0) {
        throw new Error('Cannot get last since array is empty');
    }
    return arr[arr.length - 1];
}
function nextOf(arr, item) {
    return nextOfMatching(arr, x => x === item);
}
function nextOfMatching(arr, predicate) {
    for (let i = 0; i < arr.length; i++) {
        if (predicate(arr[i])) {
            const isLast = i === arr.length - 1;
            if (isLast) {
                return null;
            }
            else {
                return arr[i + 1];
            }
        }
    }
    throw new Error('Item not in array');
}
function previousOf(arr, item) {
    return previousOfMatching(arr, x => x === item);
}
function previousOfMatching(arr, predicate) {
    for (let i = 0; i < arr.length; i++) {
        if (predicate(arr[i])) {
            if (i === 0) {
                return null;
            }
            else {
                return arr[i - 1];
            }
        }
    }
    throw new Error('Item not in array');
}

var array = /*#__PURE__*/Object.freeze({
    __proto__: null,
    limit: limit,
    filterDefined: filterDefined,
    normalizeAsArray: normalizeAsArray,
    collectProperties: collectProperties,
    index: index,
    moveElement: moveElement,
    swapElements: swapElements,
    resetWith: resetWith,
    referenceEquality: referenceEquality,
    anyMatching: anyMatching,
    allMatching: allMatching,
    firstMatching: firstMatching,
    contains: contains,
    containsAny: containsAny,
    containsAll: containsAll,
    arraysAreEqual: arraysAreEqual,
    firstMatchingValue: firstMatchingValue,
    removeMatching: removeMatching,
    replaceMatching: replaceMatching,
    keepMatching: keepMatching,
    remove: remove,
    flatten: flatten,
    groupBy: groupBy,
    requireSingle: requireSingle,
    insertBefore: insertBefore,
    first: first,
    last: last,
    nextOf: nextOf,
    nextOfMatching: nextOfMatching,
    previousOf: previousOf,
    previousOfMatching: previousOfMatching
});

class DropdownComponent {
    constructor() {
        this.showNullOption = false;
        this.placement = 'bottom-left';
        this.initialized = false;
        this.propagateChange = () => {
        };
        this.propagateTouched = () => {
        };
    }
    ngOnChanges(changes) {
        if (!this.initialized && this.options) {
            this.initialized = true;
        }
        // Reset the selection if options have changed and no longer contain the (previously) selected value, and if we can select something else
        if (this.selection && changes.options && this.options && this.options.length) {
            const currentlySelected = firstMatching(this.options, o => o.value === this.selection);
            if (!currentlySelected) {
                this.select(this.options[0]);
            }
        }
    }
    get visibleOptions() {
        if (this.showNullOption) {
            return this.options;
        }
        else {
            return this.options.filter(o => o.value != null);
        }
    }
    get selectionName() {
        // NOTE: There may be a valid match with nullish value. If there isn't, then let us consider that an initialization time issue.
        const selectedOption = firstMatching(this.options, o => o.value === this.selection);
        if (selectedOption) {
            return selectedOption.name();
        }
        else if (this.selection == null) {
            return '';
        }
        throw new Error('Dropdown options do not contain supposedly selected value.');
    }
    getIdIdentifier(option, index) {
        return option.idIdentifier ? option.idIdentifier() : index;
    }
    isSelected(option) {
        return this.selection === option.value;
    }
    select(option) {
        this.selection = option.value;
        this.propagateChange(option.value);
    }
    writeValue(obj) {
        this.selection = obj;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.propagateTouched = fn;
    }
}
DropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: DropdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: DropdownComponent, selector: "app-dropdown", inputs: { id: "id", options: "options", showNullOption: "showNullOption", placement: "placement" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropdownComponent),
            multi: true
        }], usesOnChanges: true, ngImport: i0, template: `
    <div ngbDropdown *ngIf="initialized" [placement]="placement">
      <button [id]="'selected_' + id" class="btn btn-dropdown" ngbDropdownToggle>
        <div class="selected_name">{{selectionName}}</div>
      </button>

      <div ngbDropdownMenu>
        <button *ngFor="let option of visibleOptions; let i = index"
                [id]="getIdIdentifier(option, i) + '_' + id"
                (click)="select(option)"
                class="dropdown-item"
                [class.active]="isSelected(option)">
          {{option.name()}}
        </button>
      </div>
    </div>
  `, isInline: true, styles: ["button.btn.btn-dropdown{display:flex;flex-flow:row nowrap;align-items:center}button.btn.btn-dropdown div.selected_name{max-width:13rem;overflow:hidden;text-overflow:ellipsis;flex:0 1 auto}button.btn.btn-dropdown:after{display:block;flex:0 0 auto}"], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgbDropdown, selector: "[ngbDropdown]", inputs: ["open", "placement", "container", "autoClose", "display", "dropdownClass"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i1.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i1.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: DropdownComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-dropdown',
                    styleUrls: ['./dropdown.component.scss'],
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DropdownComponent),
                            multi: true
                        }],
                    template: `
    <div ngbDropdown *ngIf="initialized" [placement]="placement">
      <button [id]="'selected_' + id" class="btn btn-dropdown" ngbDropdownToggle>
        <div class="selected_name">{{selectionName}}</div>
      </button>

      <div ngbDropdownMenu>
        <button *ngFor="let option of visibleOptions; let i = index"
                [id]="getIdIdentifier(option, i) + '_' + id"
                (click)="select(option)"
                class="dropdown-item"
                [class.active]="isSelected(option)">
          {{option.name()}}
        </button>
      </div>
    </div>
  `
                }]
        }], propDecorators: { id: [{
                type: Input
            }], options: [{
                type: Input
            }], showNullOption: [{
                type: Input
            }], placement: [{
                type: Input
            }] } });

class ErrorModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open(title, body, error) {
        const modalRef = this.modalService.open(ErrorModalComponent, { size: 'sm' });
        const instance = modalRef.componentInstance;
        instance.title = title;
        instance.body = body;
        instance.error = error;
    }
    openWithOptions(options) {
        const modalRef = this.modalService.open(ErrorModalComponent, { size: 'sm' });
        const instance = modalRef.componentInstance;
        instance.title = options.title;
        instance.body = options.body;
        instance.bodyParams = options.bodyParams;
        instance.nonTranslatableMessage = options.nonTranslatableMessage;
        instance.error = options.err;
    }
    openSubmitError(err) {
        this.open('Submit error', 'Unexpected error', err);
    }
}
ErrorModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ErrorModalService, deps: [{ token: i1.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
ErrorModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ErrorModalService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ErrorModalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.NgbModal }]; } });
class ErrorModalComponent {
    constructor(modal) {
        this.modal = modal;
    }
    close() {
        this.modal.dismiss('cancel');
    }
}
ErrorModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ErrorModalComponent, deps: [{ token: i1.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component });
ErrorModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: ErrorModalComponent, selector: "app-error-modal", inputs: { title: "title", body: "body", bodyParams: "bodyParams", nonTranslatableMessage: "nonTranslatableMessage", error: "error" }, ngImport: i0, template: `
    <div class="modal-header modal-header-danger">
      <h4 class="modal-title">
        <a><i id="close_error_modal_link" class="fa fa-times" (click)="close()"></i></a>
        <span class="text-content-wrap">
          <i class="fa fa-exclamation-circle"></i>
          {{ title | translate }}
        </span>
      </h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p translate [translateParams]="bodyParams" class="text-content-wrap">{{body}}</p>
          <pre *ngIf="error">{{error | json}}</pre>
        </div>
        <div class="col-md-12 text-content-wrap" *ngIf="nonTranslatableMessage">
          <p>{{ nonTranslatableMessage }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="close_error_modal_button" type="button" class="btn btn-action" (click)="close()" translate>Close</button>
    </div>
  `, isInline: true, styles: [""], directives: [{ type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i2.TranslatePipe, "json": i1$1.JsonPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ErrorModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-error-modal',
                    styleUrls: ['./error-modal.component.scss'],
                    template: `
    <div class="modal-header modal-header-danger">
      <h4 class="modal-title">
        <a><i id="close_error_modal_link" class="fa fa-times" (click)="close()"></i></a>
        <span class="text-content-wrap">
          <i class="fa fa-exclamation-circle"></i>
          {{ title | translate }}
        </span>
      </h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p translate [translateParams]="bodyParams" class="text-content-wrap">{{body}}</p>
          <pre *ngIf="error">{{error | json}}</pre>
        </div>
        <div class="col-md-12 text-content-wrap" *ngIf="nonTranslatableMessage">
          <p>{{ nonTranslatableMessage }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="close_error_modal_button" type="button" class="btn btn-action" (click)="close()" translate>Close</button>
    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbActiveModal }]; }, propDecorators: { title: [{
                type: Input
            }], body: [{
                type: Input
            }], bodyParams: [{
                type: Input
            }], nonTranslatableMessage: [{
                type: Input
            }], error: [{
                type: Input
            }] } });

class ExpandableTextComponent {
    constructor() {
        this.expanded = false;
        this.rows = 4;
        /**
         * Very much optional (meaning that this probably should not be used) line height parameter. Defaults to 1.5.
         */
        this.lineHeightEm = 1.5;
        /**
         * By setting captureClick to true the mouse click event expanding/collapsing the text will be stopped (stopPropagation and
         * preventDefault). This should enable use inside clickable greater containers. However, there may be side effects, so default is false.
         * Use only when needed.
         */
        this.captureClick = false;
    }
    onClick($event) {
        this.expanded = !this.expanded;
        if (this.captureClick) {
            $event.stopPropagation();
            $event.preventDefault();
        }
    }
}
ExpandableTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ExpandableTextComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ExpandableTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: ExpandableTextComponent, selector: "app-expandable-text", inputs: { text: "text", rows: "rows", lineHeightEm: "lineHeightEm", captureClick: "captureClick" }, ngImport: i0, template: `
    <div *ngIf="text" class="expandable-text-container" [ngClass]="{'expand': expanded}"
         [ngStyle]="expanded ? {'line-height.em': lineHeightEm} : {'max-height.em': rows*lineHeightEm, 'line-height.em': lineHeightEm}">
      <span class="expandable-text-content">{{text}}</span>
      <div class="expandable-text-limiter-container" [ngStyle]="expanded ? {} : {'min-height.em': rows*lineHeightEm}">
        <div class="expandable-text-limiter" [ngStyle]="expanded ? {} : {'height.em': lineHeightEm, 'top.em': (rows-1)*lineHeightEm}"
             (click)="onClick($event)"></div>
      </div>
    </div>
  `, isInline: true, styles: [".expandable-text-container{position:relative;line-height:1.5em;max-height:6em;overflow:hidden}.expandable-text-container .expandable-text-content{display:block;position:relative;margin:0;z-index:1;text-align:left}.expandable-text-container .expandable-text-limiter-container{position:absolute;top:0;bottom:0;min-height:6em;width:100%}.expandable-text-container .expandable-text-limiter{z-index:2;background:linear-gradient(0deg,#fff,#fff 10%,hsla(0,0%,100%,0));position:absolute;height:1.5em;width:100%;top:4.5em;text-align:center;cursor:pointer}.expandable-text-container.expand{max-height:none;max-height:-webkit-fit-content;max-height:-moz-fit-content;max-height:fit-content}.expandable-text-container.expand .expandable-text-limiter-container{min-height:0}.expandable-text-container.expand .expandable-text-limiter{top:auto;width:2em;height:3px;bottom:0;left:calc(50% - 1em);background:#282828;border-radius:2px}"], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ExpandableTextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-expandable-text',
                    styleUrls: ['./expandable-text.component.scss'],
                    template: `
    <div *ngIf="text" class="expandable-text-container" [ngClass]="{'expand': expanded}"
         [ngStyle]="expanded ? {'line-height.em': lineHeightEm} : {'max-height.em': rows*lineHeightEm, 'line-height.em': lineHeightEm}">
      <span class="expandable-text-content">{{text}}</span>
      <div class="expandable-text-limiter-container" [ngStyle]="expanded ? {} : {'min-height.em': rows*lineHeightEm}">
        <div class="expandable-text-limiter" [ngStyle]="expanded ? {} : {'height.em': lineHeightEm, 'top.em': (rows-1)*lineHeightEm}"
             (click)="onClick($event)"></div>
      </div>
    </div>
  `
                }]
        }], propDecorators: { text: [{
                type: Input
            }], rows: [{
                type: Input
            }], lineHeightEm: [{
                type: Input
            }], captureClick: [{
                type: Input
            }] } });

class FilterDropdownComponent {
    constructor() {
        this.placement = 'bottom-left';
    }
    get selection() {
        return this.filterSubject.getValue();
    }
    set selection(value) {
        this.filterSubject.next(value);
    }
}
FilterDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: FilterDropdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FilterDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: FilterDropdownComponent, selector: "app-filter-dropdown", inputs: { id: "id", options: "options", filterSubject: "filterSubject", placement: "placement" }, ngImport: i0, template: `
    <app-dropdown [id]="id"
                  [options]="options"
                  [showNullOption]="true"
                  [placement]="placement"
                  [(ngModel)]="selection"></app-dropdown>
  `, isInline: true, components: [{ type: DropdownComponent, selector: "app-dropdown", inputs: ["id", "options", "showNullOption", "placement"] }], directives: [{ type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: FilterDropdownComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-filter-dropdown',
                    template: `
    <app-dropdown [id]="id"
                  [options]="options"
                  [showNullOption]="true"
                  [placement]="placement"
                  [(ngModel)]="selection"></app-dropdown>
  `
                }]
        }], propDecorators: { id: [{
                type: Input
            }], options: [{
                type: Input
            }], filterSubject: [{
                type: Input
            }], placement: [{
                type: Input
            }] } });

class FooterComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.informationClick = new EventEmitter();
    }
    get licenseLink() {
        return 'https://ec.europa.eu/info/european-union-public-licence';
    }
    get licenseIconLink() {
        return 'https://creativecommons.org/licenses/by/4.0/';
    }
    get feedbackLink() {
        const subject = this.translateService.instant('Contact') + ':%20' + this.title;
        return 'mailto:yhteentoimivuus@dvv.fi?subject=' + subject;
    }
    get descriptionOfFileLink() {
        return 'https://wiki.dvv.fi/display/YTIJD/Tietosuojaseloste';
    }
    get accessibilityLink() {
        return 'https://wiki.dvv.fi/display/YTIJD/Saavutettavuusseloste';
    }
    showUserSupportLink() {
        return false;
    }
}
FooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: FooterComponent, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
FooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: FooterComponent, selector: "app-footer", inputs: { title: "title", version: "version", showLicenseIcon: "showLicenseIcon" }, outputs: { informationClick: "informationClick" }, ngImport: i0, template: `

    <div class="container-fluid">

      <div class="row">
        <div class="col-12 pb-2">
          <a href="/"><h4 class="title">{{title}}</h4></a>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <p translate>This service is developed and maintained by Digital and Population Data Services Agency</p>
        </div>

        <div class="col-md-4">

          <ul class="link-list">
            <li>
              <a id="information_link" (click)="informationClick.emit()" translate>Information about the service</a>
            </li>
            <li>
              <a id="description_of_file_link" [href]="descriptionOfFileLink" target="_blank" rel="noopener noreferrer" translate>Description of file</a>
            </li>
            <li>
              <a id="accessibility_link" [href]="accessibilityLink" target="_blank" rel="noopener noreferrer" translate>Accessibility</a>
            </li>
            <li *ngIf="showUserSupportLink()">
              <a id="user_support_link" href="/ohjeet" translate>User support</a>
            </li>
            <li>
              <a id="feedback_link" [href]="feedbackLink" translate>Feedback</a>
            </li>
          </ul>
        </div>

        <div class="col-md-4">
          <ul class="link-list">
            <li>
              <a id="license_link" [href]="licenseLink" target="_blank" rel="noopener noreferrer" translate>Sourcecode is licensed under EUPL-1.2 license.</a>
            </li>
            <li *ngIf="showLicenseIcon" class="">
              <a id="licence_icon_text_link" [href]="licenseIconLink" target="_blank" rel="noopener noreferrer" translate>Content has been licensed with CC by 4.0 license.</a>
            </li>
          </ul>
        </div>
      </div>

      <div *ngIf="version" class="row">
        <div class="col-md-12 version">{{version}}</div>
      </div>

    </div>
  `, isInline: true, styles: [".container-fluid{background-color:#fff}.title{color:#003479}a{cursor:pointer;font-size:smaller;color:#2a6ebb!important}a:hover{text-decoration:underline!important}h4{font-weight:600;margin-top:.5rem}ul{list-style:none}p{font-size:18px}.link-image{border-width:0;border-style:none;padding-top:5px;padding-right:5px}.version{color:#fff;font-size:60%;text-align:center}"], directives: [{ type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: FooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-footer',
                    styleUrls: ['./footer.component.scss'],
                    template: `

    <div class="container-fluid">

      <div class="row">
        <div class="col-12 pb-2">
          <a href="/"><h4 class="title">{{title}}</h4></a>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <p translate>This service is developed and maintained by Digital and Population Data Services Agency</p>
        </div>

        <div class="col-md-4">

          <ul class="link-list">
            <li>
              <a id="information_link" (click)="informationClick.emit()" translate>Information about the service</a>
            </li>
            <li>
              <a id="description_of_file_link" [href]="descriptionOfFileLink" target="_blank" rel="noopener noreferrer" translate>Description of file</a>
            </li>
            <li>
              <a id="accessibility_link" [href]="accessibilityLink" target="_blank" rel="noopener noreferrer" translate>Accessibility</a>
            </li>
            <li *ngIf="showUserSupportLink()">
              <a id="user_support_link" href="/ohjeet" translate>User support</a>
            </li>
            <li>
              <a id="feedback_link" [href]="feedbackLink" translate>Feedback</a>
            </li>
          </ul>
        </div>

        <div class="col-md-4">
          <ul class="link-list">
            <li>
              <a id="license_link" [href]="licenseLink" target="_blank" rel="noopener noreferrer" translate>Sourcecode is licensed under EUPL-1.2 license.</a>
            </li>
            <li *ngIf="showLicenseIcon" class="">
              <a id="licence_icon_text_link" [href]="licenseIconLink" target="_blank" rel="noopener noreferrer" translate>Content has been licensed with CC by 4.0 license.</a>
            </li>
          </ul>
        </div>
      </div>

      <div *ngIf="version" class="row">
        <div class="col-md-12 version">{{version}}</div>
      </div>

    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: i2.TranslateService }]; }, propDecorators: { title: [{
                type: Input
            }], version: [{
                type: Input
            }], showLicenseIcon: [{
                type: Input
            }], informationClick: [{
                type: Output
            }] } });

const warningSvgIcon = '../assets/icons/material/ic_warning_24px.svg';
const warningMaterialIcon = { name: 'warning', colorClass: 'icon-danger' };
const vocabularyTypeMaterialIcons = {
    'Vocabulary': { name: 'chat_bubble_outline', colorClass: 'icon-danger' },
    'TerminologicalVocabulary': { name: 'chat_bubble', colorClass: 'icon-orange' }
};
const informationDomainSvgIcons = {
    'P1': '../assets/icons/kapa/icon_asuminen.svg',
    'P2': '../assets/icons/kapa/icon_kerrostalo.svg',
    'P3': '../assets/icons/kapa/icon_perhe.svg',
    'P4': '../assets/icons/kapa/icon_muutokset_ja_kriisitilanteet.svg',
    'P5': '../assets/icons/kapa/icon_laakari.svg',
    'P6': '../assets/icons/kapa/icon_esitys.svg',
    'P7': '../assets/icons/kapa/icon_oikeus.svg',
    'P8': '../assets/icons/kapa/icon_vaaka_2.svg',
    'P9': '../assets/icons/kapa/icon_hallintorakennus.svg',
    'P10': '../assets/icons/kapa/icon_kayttaja.svg',
    'P11': '../assets/icons/kapa/icon_yrittaja.svg',
    'P12': '../assets/icons/kapa/icon_tyonantajuus.svg',
    'P13': '../assets/icons/kapa/icon_laina.svg',
    'P14': '../assets/icons/kapa/icon_talous.svg',
    'P15': '../assets/icons/kapa/icon_taloustiedot.svg',
    'P16': '../assets/icons/kapa/icon_liikenne.svg',
    'P17': '../assets/icons/kapa/icon_kansainvalistyminen.svg',
    'P18': '../assets/icons/kapa/icon_kartat.svg',
    'P19': '../assets/icons/kapa/icon_yhteistyo.svg',
    'P20': '../assets/icons/kapa/icon_ratkaisu.svg',
    'P21': '../assets/icons/kapa/icon_pankkikortit.svg',
    'P22': '../assets/icons/kapa/icon_palveluvayla.svg',
    'P23': '../assets/icons/kapa/icon_kauppa.svg',
    'P24': '../assets/icons/kapa/icon_kasvu.svg',
    'P25': '../assets/icons/kapa/icon_kulttuuri.svg',
    'P26': '../assets/icons/kapa/icon_keskustelu.svg',
    'P27': '../assets/icons/kapa/icon_liikunta.svg' // Liikunta ja ulkoilu
};
const dataModelingMaterialIcons = {
    'library': { name: 'view_column', colorClass: 'icon-brand' },
    'profile': { name: 'view_quilt', colorClass: 'icon-orange' },
    'class': { name: 'web_asset', colorClass: 'icon-blend' },
    'shape': { name: 'web', colorClass: 'icon-blend' },
    'attribute': { name: 'text_format', colorClass: 'icon-blend' },
    'association': { name: 'low_priority', colorClass: 'icon-blend' } // Assosiaatio
};
const uiMaterialIcons = {
    'delete': { name: 'delete_forever', colorClass: 'icon-blend' },
    'dragAndDrop': { name: 'import_export', colorClass: 'icon-blend' },
    'closeModal': { name: 'close', colorClass: 'icon-blend' },
    'search': { name: 'search', colorClass: 'icon-blend' }
};
/**
 * Get material icon name for vocabulary types. Use with
 * ```
 * <i class="material-icons {{colorClass}}">{{name}}</i>
 * ```
 * @param typeId 'TerminologicalVocabulary' or 'Vocabulary'
 */
function getVocabularyTypeMaterialIcon(typeId) {
    const icon = vocabularyTypeMaterialIcons[typeId];
    return icon || warningMaterialIcon;
}
/**
 * Get svg icon for information domain (previously known as classification or group). Use with
 * ```
 * <img [src]=ICON>
 * ```
 * @param domainId For example 'P8'.
 */
function getInformationDomainSvgIcon(domainId) {
    const icon = informationDomainSvgIcons[domainId];
    return icon || warningSvgIcon;
}
/**
 * Get material icon name for various data modeling terms. Use with
 * ```
 * <i class="material-icons {{colorClass}}">{{name}}</i>
 * ```
 * @param type For example 'attribute'.
 */
function getDataModelingMaterialIcon(type) {
    const icon = dataModelingMaterialIcons[type];
    return icon || warningMaterialIcon;
}
/**
 * Get material icon name for various ui actions. Use with
 * ```
 * <i class="material-icons {{colorClass}}">{{name}}</i>
 * ```
 * @param action For example 'dragAndDrop'.
 */
function getUiMaterialIcon(action) {
    const icon = uiMaterialIcons[action];
    return icon || warningMaterialIcon;
}

var IconCategory;
(function (IconCategory) {
    IconCategory["VocabularyType"] = "VOCABULARY_TYPE";
    IconCategory["DataModeling"] = "DATA_MODELING";
    IconCategory["InformationDomain"] = "INFORMATION_DOMAIN";
    IconCategory["UI"] = "UI";
})(IconCategory || (IconCategory = {}));
/**
 * Icon component that may be used instead of utils/icons utility. NOTE: Work in progress, as styling is currently impossible!
 */
class IconComponent {
    constructor() {
        this.CategoryType = IconCategory;
    }
    vocabularyTypeIconDef(id) {
        return getVocabularyTypeMaterialIcon(id);
    }
    dataModelingIconDef(id) {
        return getDataModelingMaterialIcon(id);
    }
    informationDomainIconSrc(id) {
        return getInformationDomainSvgIcon(id);
    }
    uiIconDef(id) {
        return getUiMaterialIcon(id);
    }
}
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: IconComponent, selector: "app-icon", inputs: { category: "category", id: "id" }, ngImport: i0, template: `
    <ng-container [ngSwitch]="category">
      <i *ngSwitchCase="CategoryType.VocabularyType"
         class="yti-icon material-icons {{vocabularyTypeIconDef(id).colorClass}}">{{vocabularyTypeIconDef(id).name}}</i>
      <i *ngSwitchCase="CategoryType.DataModeling"
         class="yti-icon material-icons {{dataModelingIconDef(id).colorClass}}">{{dataModelingIconDef(id).name}}</i>
      <img *ngSwitchCase="CategoryType.InformationDomain" class="yti-icon" [src]="informationDomainIconSrc(id)">
      <i *ngSwitchCase="CategoryType.UI" class="yti-icon {{uiIconDef(id).colorClass}}">{{uiIconDef(id).name}}</i>
      <i *ngSwitchDefault class="yti-icon material-icons icon-danger">warning</i>
    </ng-container>
  `, isInline: true, styles: ["i.yti-icon{color:#282828;vertical-align:middle}img.yti-icon{width:24px;height:24px;margin:0;padding:0}"], directives: [{ type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-icon',
                    styleUrls: ['./icon.component.scss'],
                    template: `
    <ng-container [ngSwitch]="category">
      <i *ngSwitchCase="CategoryType.VocabularyType"
         class="yti-icon material-icons {{vocabularyTypeIconDef(id).colorClass}}">{{vocabularyTypeIconDef(id).name}}</i>
      <i *ngSwitchCase="CategoryType.DataModeling"
         class="yti-icon material-icons {{dataModelingIconDef(id).colorClass}}">{{dataModelingIconDef(id).name}}</i>
      <img *ngSwitchCase="CategoryType.InformationDomain" class="yti-icon" [src]="informationDomainIconSrc(id)">
      <i *ngSwitchCase="CategoryType.UI" class="yti-icon {{uiIconDef(id).colorClass}}">{{uiIconDef(id).name}}</i>
      <i *ngSwitchDefault class="yti-icon material-icons icon-danger">warning</i>
    </ng-container>
  `
                }]
        }], propDecorators: { category: [{
                type: Input
            }], id: [{
                type: Input
            }] } });

class InformationSymbolComponent {
}
InformationSymbolComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: InformationSymbolComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InformationSymbolComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: InformationSymbolComponent, selector: "app-information-symbol", inputs: { infoText: "infoText" }, ngImport: i0, template: `<i *ngIf="infoText" class="fa fa-info-circle" [ngbTooltip]="infoText | translate"></i>`, isInline: true, styles: [".fa-info-circle{color:#2a6ebb;font-size:small;padding-left:.2em}"], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], pipes: { "translate": i2.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: InformationSymbolComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-information-symbol',
                    styleUrls: ['./information-symbol.component.scss'],
                    template: `<i *ngIf="infoText" class="fa fa-info-circle" [ngbTooltip]="infoText | translate"></i>`
                }]
        }], propDecorators: { infoText: [{
                type: Input
            }] } });

function hasAny(set, values) {
    for (const value of normalizeAsArray(values)) {
        if (set.has(value)) {
            return true;
        }
    }
    return false;
}
function combineResultSets(map, keys) {
    return combineSets(normalizeAsArray(keys).map(key => map.get(key) || new Set()));
}
function combineSets(sets) {
    switch (sets.length) {
        case 0:
            return new Set();
        case 1:
            return sets[0];
        default:
            const result = new Set();
            for (const set of sets) {
                set.forEach(value => result.add(value));
            }
            return result;
    }
}
function getOrCreateSet(map, key) {
    const set = map.get(key);
    if (set) {
        return set;
    }
    else {
        const newSet = new Set();
        map.set(key, newSet);
        return newSet;
    }
}
function convertToMapSet(mapSetLike) {
    const map = new Map();
    for (const entry of Object.entries(mapSetLike)) {
        const key = entry[0];
        const values = entry[1];
        const set = getOrCreateSet(map, key);
        for (const value of values) {
            set.add(value);
        }
    }
    return map;
}

var set = /*#__PURE__*/Object.freeze({
    __proto__: null,
    hasAny: hasAny,
    combineResultSets: combineResultSets,
    combineSets: combineSets,
    getOrCreateSet: getOrCreateSet,
    convertToMapSet: convertToMapSet
});

const AUTHENTICATED_USER_ENDPOINT = new InjectionToken('authenticated.user.endpoint');
class User {
    constructor(json) {
        this.id = json.id;
        this.email = json.email;
        this.firstName = json.firstName;
        this.lastName = json.lastName;
        this.anonymous = json.anonymous;
        this.superuser = json.superuser;
        this.rolesInOrganizations = convertToMapSet(json.rolesInOrganizations);
        this.organizationsInRole = convertToMapSet(json.organizationsInRole);
        this.hasToken = json.tokenCreatedAt != null && json.tokenInvalidationAt != null;
        if (json.containerUri != null) {
            this.containerUri = json.containerUri;
        }
        if (json.tokenRole != null) {
            this.tokenRole = json.tokenRole;
        }
    }
    get name() {
        return this.firstName + ' ' + this.lastName;
    }
    isAdminInAnyOrganization() {
        return this.isInRoleInAnyOrganization('ADMIN');
    }
    isInRoleInAnyOrganization(roles) {
        return this.getOrganizations(roles).size > 0;
    }
    getRoles(organizationIds) {
        return combineResultSets(this.rolesInOrganizations, organizationIds);
    }
    getOrganizations(roles) {
        return combineResultSets(this.organizationsInRole, roles);
    }
    isInRole(role, organizationIds) {
        return hasAny(this.getRoles(organizationIds), role);
    }
    isInOrganization(organizationIds, roles) {
        return hasAny(this.getOrganizations(roles), organizationIds);
    }
}
const anonymousUser = new User({
    id: undefined,
    email: '',
    firstName: '',
    lastName: '',
    anonymous: true,
    superuser: false,
    rolesInOrganizations: {},
    organizationsInRole: {},
    hasToken: false,
    containerUri: undefined,
    tokenRole: undefined
});
const oneMinuteInMs = 60 * 1000;
class UserService {
    constructor(http, authenticatedUserEndpoint) {
        this.http = http;
        this.authenticatedUserEndpoint = authenticatedUserEndpoint;
        this._user$ = new BehaviorSubject(anonymousUser);
        this.updateLoggedInUser().catch(reason => console.error('Resolving user failed: ' + reason));
        setInterval(() => {
            if (!this.user.anonymous) {
                this.updateLoggedInUser().catch(reason => console.error('Resolving user failed: ' + reason));
                ;
            }
        }, oneMinuteInMs);
    }
    get user$() {
        return this._user$.asObservable();
    }
    get user() {
        return this._user$.getValue();
    }
    get loggedIn$() {
        return this._user$.pipe(map$1(u => !u.anonymous));
    }
    updateLoggedInUser(fakeLoginMail) {
        return new Promise((resolve, reject) => {
            let params = new HttpParams();
            if (fakeLoginMail) {
                params = params.append('fake.login.mail', fakeLoginMail);
            }
            this.http.get(this.authenticatedUserEndpoint, { params })
                .subscribe((body) => {
                const newUser = new User(body);
                if (!compareUsers(this.user, newUser)) {
                    this._user$.next(newUser);
                }
                resolve(this.user);
            }, err => {
                reject(err instanceof HttpErrorResponse ? err.message ? err.message : err.error ? err.error : err.statusText : err);
            });
        });
    }
    isLoggedIn() {
        return !this.user.anonymous;
    }
    register() {
        window.open('http://id.eduuni.fi/signup', '_blank');
    }
    login() {
        const currentUrl = window.location.href;
        window.location.href = `/Shibboleth.sso/Login?target=${encodeURIComponent(currentUrl)}`;
    }
    logout() {
        const currentUrl = `${window.location.origin}/logout.html`;
        window.location.href = `/Shibboleth.sso/Logout?return=${encodeURIComponent(currentUrl)}`;
    }
}
UserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: UserService, deps: [{ token: i1$3.HttpClient }, { token: AUTHENTICATED_USER_ENDPOINT }], target: i0.ɵɵFactoryTarget.Injectable });
UserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: UserService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: UserService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTHENTICATED_USER_ENDPOINT]
                }] }]; } });
function compareUsers(user1, user2) {
    return user1.email === user2.email &&
        user1.firstName === user2.firstName &&
        user1.lastName === user2.lastName &&
        user1.anonymous === user2.anonymous &&
        user1.superuser === user2.superuser &&
        compareRoles(user1.rolesInOrganizations, user2.rolesInOrganizations);
}
function compareRoles(rolesInOrganizations1, rolesInOrganizations2) {
    if (rolesInOrganizations1.size !== rolesInOrganizations2.size) {
        return false;
    }
    // TODO: This should work:
    //       for (let [id, roles1] of rolesInOrganizations1) {
    const iter = rolesInOrganizations1.entries();
    let next = iter.next();
    while (!next.done) {
        const [id, roles1] = next.value;
        let roles2 = rolesInOrganizations2.get(id);
        if (!roles2 || roles1.size !== roles2.size) {
            return false;
        }
        const roleIter = roles1.keys();
        let nextRole = roleIter.next();
        while (!nextRole.done) {
            let role = nextRole.value;
            if (!roles2.has(role)) {
                return false;
            }
            nextRole = roleIter.next();
        }
        next = iter.next();
    }
    return true;
}

class LoginModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open() {
        this.modalService.open(LoginModalComponent, { size: 'sm' });
    }
}
LoginModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: LoginModalService, deps: [{ token: i1.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
LoginModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: LoginModalService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: LoginModalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.NgbModal }]; } });
class LoginModalComponent {
    constructor(modal, userService) {
        this.modal = modal;
        this.userService = userService;
    }
    cancel() {
        this.modal.dismiss('cancel');
    }
    login() {
        this.userService.login();
    }
    register() {
        this.userService.register();
    }
}
LoginModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: LoginModalComponent, deps: [{ token: i1.NgbActiveModal }, { token: UserService }], target: i0.ɵɵFactoryTarget.Component });
LoginModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: LoginModalComponent, selector: "app-login-modal", ngImport: i0, template: `
    <div class="modal-header">
      <h4 class="modal-title">
        <a><i id="close_login_modal_link" class="fa fa-times" (click)="cancel()"></i></a>
        <span translate>Login</span>
      </h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p translate>eDuuni information</p>
          <p translate>Login information</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="login_modal_button" type="button" class="btn btn-action" (click)="login()" translate>Log In</button>
      <button id="register_login_modal_button" type="button" class="btn btn-action" (click)="register()" translate>Register</button>
    </div>
  `, isInline: true, styles: [""], directives: [{ type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: LoginModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-login-modal',
                    styleUrls: ['./login-modal.component.scss'],
                    template: `
    <div class="modal-header">
      <h4 class="modal-title">
        <a><i id="close_login_modal_link" class="fa fa-times" (click)="cancel()"></i></a>
        <span translate>Login</span>
      </h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p translate>eDuuni information</p>
          <p translate>Login information</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="login_modal_button" type="button" class="btn btn-action" (click)="login()" translate>Log In</button>
      <button id="register_login_modal_button" type="button" class="btn btn-action" (click)="register()" translate>Register</button>
    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbActiveModal }, { type: UserService }]; } });

class MenuComponent {
}
MenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: MenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: MenuComponent, selector: "app-menu", ngImport: i0, template: "<svg viewBox=\"0 0 30 30\" version=\"1.1\">\n\n  <title>Menu</title>\n\n  <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g fill=\"#636769\">\n      <path d=\"M26,16 L4,16 C3.448,16 3,15.552 3,15 C3,14.448 3.448,14 4,14 L26,14 C26.552,14 27,14.448 27,15 C27,15.552 26.552,16 26,16 Z M26,9 L4,9 C3.448,9 3,8.552 3,8 C3,7.448 3.448,7 4,7 L26,7 C26.552,7 27,7.448 27,8 C27,8.552 26.552,9 26,9 Z M4,21 L26,21 C26.552,21 27,21.448 27,22 C27,22.552 26.552,23 26,23 L4,23 C3.448,23 3,22.552 3,22 C3,21.448 3.448,21 4,21 Z\"></path>\n    </g>\n  </g>\n\n</svg>\n\n<span class=\"menu-text\" translate>MENU</span>\n", styles: [":host{display:inline-block;text-align:center}:host svg{width:30px;height:30px}:host .menu-text{color:#282828;text-transform:uppercase;display:block;font-size:xx-small;line-height:0}"], directives: [{ type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: MenuComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-menu',
                    templateUrl: './menu.component.html',
                    styleUrls: ['./menu.component.scss']
                }]
        }] });

class PopoverCloseComponent {
    close() {
        this.popover.close();
    }
}
PopoverCloseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: PopoverCloseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PopoverCloseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: PopoverCloseComponent, selector: "app-popover-close", inputs: { popover: "popover" }, ngImport: i0, template: `<i id="popover_close_link" class="fa fa-times" (click)="close()"></i>`, isInline: true, styles: ["i{position:absolute;right:7px;top:7px;cursor:pointer}"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: PopoverCloseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-popover-close',
                    styleUrls: ['./popover-close.component.scss'],
                    template: `<i id="popover_close_link" class="fa fa-times" (click)="close()"></i>`
                }]
        }], propDecorators: { popover: [{
                type: Input
            }] } });

class RequiredSymbolComponent {
    constructor() {
        this.tooltipText = 'Required';
    }
}
RequiredSymbolComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: RequiredSymbolComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RequiredSymbolComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: RequiredSymbolComponent, selector: "app-required-symbol", inputs: { tooltipText: "tooltipText" }, ngImport: i0, template: `<i class="fa fa-asterisk" [ngbTooltip]="tooltipText | translate"></i>`, isInline: true, styles: [".fa-asterisk{color:#c13832;font-size:small;padding-left:.2em}"], directives: [{ type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], pipes: { "translate": i2.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: RequiredSymbolComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-required-symbol',
                    styleUrls: ['./required-symbol.component.scss'],
                    template: `<i class="fa fa-asterisk" [ngbTooltip]="tooltipText | translate"></i>`
                }]
        }], propDecorators: { tooltipText: [{
                type: Input
            }] } });

class StatusComponent {
    get white() {
        return this.status === 'INCOMPLETE';
    }
    get gray() {
        return this.status === 'DRAFT' || this.status === 'SUGGESTED';
    }
    get danger() {
        return this.status === 'RETIRED' || this.status === 'INVALID';
    }
    get warning() {
        return this.status === 'SUPERSEDED';
    }
    get success() {
        return this.status === 'VALID';
    }
}
StatusComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: StatusComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StatusComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: StatusComponent, selector: "app-status", inputs: { status: "status" }, ngImport: i0, template: `
    <span [class.bg-danger]="danger"
          [class.bg-warning]="warning"
          [class.bg-gray]="gray"
          [class.bg-white]="white"
          [class.bg-success]="success">{{status | translate}}</span>
  `, isInline: true, styles: [":host{display:inline-block}span{color:#fff;border-radius:3px;padding:3px 10px}span.bg-white{color:#282828!important;border:1px solid #282828}"], pipes: { "translate": i2.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: StatusComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-status',
                    styleUrls: ['./status.component.scss'],
                    template: `
    <span [class.bg-danger]="danger"
          [class.bg-warning]="warning"
          [class.bg-gray]="gray"
          [class.bg-white]="white"
          [class.bg-success]="success">{{status | translate}}</span>
  `
                }]
        }], propDecorators: { status: [{
                type: Input
            }] } });

const allStatuses = ['INCOMPLETE', 'DRAFT', 'SUGGESTED', 'VALID', 'SUPERSEDED', 'RETIRED', 'INVALID'];
const selectableStatuses = ['INCOMPLETE', 'DRAFT', 'VALID', 'SUPERSEDED', 'RETIRED', 'INVALID'];
const restrictedStatuses = ['VALID', 'SUPERSEDED', 'RETIRED', 'INVALID'];
const regularStatuses = ['DRAFT', 'SUGGESTED', 'VALID', 'SUPERSEDED', 'RETIRED', 'INVALID'];
const creationTimeAllowedStatuses = ['DRAFT', 'INCOMPLETE'];
function allowedTargetStatuses(fromStatus, includeFrom = true) {
    const allowedTargetStatusesFrom_INCOMPLETE = ['DRAFT'];
    const allowedTargetStatusesFrom_DRAFT = ['INCOMPLETE', 'VALID'];
    const allowedTargetStatusesFrom_VALID = ['SUPERSEDED', 'RETIRED', 'INVALID'];
    const allowedTargetStatusesFrom_SUPERSEDED = ['VALID', 'RETIRED', 'INVALID'];
    const allowedTargetStatusesFrom_RETIRED = ['VALID', 'SUPERSEDED', 'INVALID'];
    const allowedTargetStatusesFrom_INVALID = ['VALID', 'SUPERSEDED', 'RETIRED'];
    const includeFromStatusIfNeeded = (statuses) => {
        if (includeFrom) {
            statuses.unshift(fromStatus);
        }
        return statuses;
    };
    if (fromStatus === 'INCOMPLETE') {
        return includeFromStatusIfNeeded(allowedTargetStatusesFrom_INCOMPLETE);
    }
    else if (fromStatus === 'DRAFT') {
        return includeFromStatusIfNeeded(allowedTargetStatusesFrom_DRAFT);
    }
    else if (fromStatus === 'VALID') {
        return includeFromStatusIfNeeded(allowedTargetStatusesFrom_VALID);
    }
    else if (fromStatus === 'SUPERSEDED') {
        return includeFromStatusIfNeeded(allowedTargetStatusesFrom_SUPERSEDED);
    }
    else if (fromStatus === 'RETIRED') {
        return includeFromStatusIfNeeded(allowedTargetStatusesFrom_RETIRED);
    }
    else if (fromStatus === 'INVALID') {
        return includeFromStatusIfNeeded(allowedTargetStatusesFrom_INVALID);
    }
    else {
        return selectableStatuses; // should never come here
    }
}
function changeToRestrictedStatus(fromStatus, toStatus) {
    return !contains(restrictedStatuses, fromStatus) && contains(restrictedStatuses, toStatus);
}

class StatusDropdownComponent {
    constructor() {
        this.placement = 'bottom-left';
        this.restrict = false;
        this.isSuperUser = false;
        this.allowOnlyCreationTimeStatuses = false;
        this.propagateChange = () => { };
        this.propagateTouched = () => { };
    }
    get options() {
        if (this.isSuperUser) {
            return selectableStatuses;
        }
        if (this.allowOnlyCreationTimeStatuses) {
            return creationTimeAllowedStatuses;
        }
        if (this.restrict) {
            return restrictedStatuses;
        }
        else if (this.originalStatus) {
            return allowedTargetStatuses(this.originalStatus);
        }
        else {
            return selectableStatuses;
        }
    }
    isSelected(option) {
        return this.selection === option;
    }
    select(option) {
        this.selection = option;
        this.propagateChange(option);
    }
    writeValue(obj) {
        this.selection = obj;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.propagateTouched = fn;
    }
}
StatusDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: StatusDropdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StatusDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: StatusDropdownComponent, selector: "app-status-dropdown", inputs: { id: "id", placement: "placement", restrict: "restrict", isSuperUser: "isSuperUser", originalStatus: "originalStatus", allowOnlyCreationTimeStatuses: "allowOnlyCreationTimeStatuses" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StatusDropdownComponent),
            multi: true
        }], ngImport: i0, template: `
    <div ngbDropdown [placement]="placement">
      <button [id]="'selected_' + id" class="btn btn-dropdown" ngbDropdownToggle>
        <span>{{selection | translate}}</span>
      </button>

      <div ngbDropdownMenu>
        <button *ngFor="let option of options"
                [id]="option + '_' + id"
                (click)="select(option)"
                class="dropdown-item"
                [class.active]="isSelected(option)">
          {{option | translate}}
        </button>
      </div>
    </div>
  `, isInline: true, directives: [{ type: i1.NgbDropdown, selector: "[ngbDropdown]", inputs: ["open", "placement", "container", "autoClose", "display", "dropdownClass"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i1.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i1.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i2.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: StatusDropdownComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-status-dropdown',
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => StatusDropdownComponent),
                            multi: true
                        }],
                    template: `
    <div ngbDropdown [placement]="placement">
      <button [id]="'selected_' + id" class="btn btn-dropdown" ngbDropdownToggle>
        <span>{{selection | translate}}</span>
      </button>

      <div ngbDropdownMenu>
        <button *ngFor="let option of options"
                [id]="option + '_' + id"
                (click)="select(option)"
                class="dropdown-item"
                [class.active]="isSelected(option)">
          {{option | translate}}
        </button>
      </div>
    </div>
  `
                }]
        }], propDecorators: { id: [{
                type: Input
            }], placement: [{
                type: Input
            }], restrict: [{
                type: Input
            }], isSuperUser: [{
                type: Input
            }], originalStatus: [{
                type: Input
            }], allowOnlyCreationTimeStatuses: [{
                type: Input
            }] } });

class ClipboardComponent {
    constructor(clipboardService, translateService) {
        this.clipboardService = clipboardService;
        this.translateService = translateService;
        /**
         * Whether to assume the displayValue to be a link and render it as such.
         */
        this.showAsLink = false;
    }
    get translateParams() {
        return {
            value: this.description ? this.description : this.displayValue ? this.displayValue : this.translateService.instant('value')
        };
    }
    clickToolTip() {
        const content = typeof this.value === 'string' ? this.value : this.value ? this.value() : this.displayValue;
        if (content) {
            this.clipboardService.copyFromContent(content);
            this.tooltip.close();
            setTimeout(() => {
                this.popover.close();
            }, 1500);
        }
        else {
            this.tooltip.close();
            setTimeout(() => {
                this.popover.close();
            }, 0);
        }
    }
}
ClipboardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ClipboardComponent, deps: [{ token: i1$4.ClipboardService }, { token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
ClipboardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.5", type: ClipboardComponent, selector: "app-clipboard", inputs: { displayValue: "displayValue", showAsLink: "showAsLink", value: "value", description: "description" }, viewQueries: [{ propertyName: "tooltip", first: true, predicate: ["t"], descendants: true }, { propertyName: "popover", first: true, predicate: ["p"], descendants: true }], ngImport: i0, template: `
      <a *ngIf="displayValue && showAsLink" target="_blank" rel="noopener noreferrer" href="{{displayValue}}">{{displayValue}}</a>
      <span *ngIf="displayValue && !showAsLink">{{displayValue}}</span>
      <i class="far fa-copy"
         #t="ngbTooltip"
         ngbTooltip="{{'Copy value to clipboard' | translate:translateParams}}"
         #p="ngbPopover"
         ngbPopover="{{'Copied to clipboard' | translate}}"
         ngxClipboard
         (click)="clickToolTip()"></i>
  `, isInline: true, styles: ["i{padding-left:.3em;max-width:1000px}"], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$4.ClipboardDirective, selector: "[ngxClipboard]", inputs: ["ngxClipboard", "container", "cbContent", "cbSuccessMsg"], outputs: ["cbOnSuccess", "cbOnError"] }, { type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i1.NgbPopover, selector: "[ngbPopover]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disablePopover", "popoverClass", "openDelay", "closeDelay", "ngbPopover", "popoverTitle"], outputs: ["shown", "hidden"], exportAs: ["ngbPopover"] }], pipes: { "translate": i2.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ClipboardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-clipboard',
                    styleUrls: ['./clipboard.scss'],
                    template: `
      <a *ngIf="displayValue && showAsLink" target="_blank" rel="noopener noreferrer" href="{{displayValue}}">{{displayValue}}</a>
      <span *ngIf="displayValue && !showAsLink">{{displayValue}}</span>
      <i class="far fa-copy"
         #t="ngbTooltip"
         ngbTooltip="{{'Copy value to clipboard' | translate:translateParams}}"
         #p="ngbPopover"
         ngbPopover="{{'Copied to clipboard' | translate}}"
         ngxClipboard
         (click)="clickToolTip()"></i>
  `
                }]
        }], ctorParameters: function () { return [{ type: i1$4.ClipboardService }, { type: i2.TranslateService }]; }, propDecorators: { tooltip: [{
                type: ViewChild,
                args: ['t']
            }], popover: [{
                type: ViewChild,
                args: ['p']
            }], displayValue: [{
                type: Input
            }], showAsLink: [{
                type: Input
            }], value: [{
                type: Input
            }], description: [{
                type: Input
            }] } });

/* FIXME: Pipe produces HTML output which has to be bound with innerHTML-attribute in the template.
          Malicious user input cannot be sanitized with this mechanism and it causes security problems.
          Angular 1 had $sce service which allowed trusting of html content partially and angular 2 doesn't have on yer.
*/
class HighlightPipe {
    transform(text, highlightRegexp) {
        if (!text || !highlightRegexp) {
            return text;
        }
        return text.replace(highlightRegexp, '<span class="highlight">$&</span>');
    }
}
HighlightPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: HighlightPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
HighlightPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: HighlightPipe, name: "highlight" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: HighlightPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'highlight' }]
        }] });

class KeysPipe {
    transform(obj) {
        if (!obj) {
            return [];
        }
        return Object.keys(obj);
    }
}
KeysPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: KeysPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
KeysPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: KeysPipe, name: "keys" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: KeysPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'keys' }]
        }] });

function reversed(comparator) {
    return makeChainable((lhs, rhs) => comparator(rhs, lhs));
}
function comparingPrimitive(propertyExtractor) {
    return makeChainable(property(propertyExtractor, optional(primitiveComparator)));
}
function comparingLocalizable(localizer, propertyExtractor, useUILanguage = true) {
    return makeChainable(property(propertyExtractor, optional(localized(localizer, useUILanguage, stringComparatorIgnoringCase))));
}
function primitiveComparator(lhs, rhs) {
    return lhs === rhs ? 0 : lhs > rhs ? 1 : -1;
}
function stringComparatorIgnoringCase(lhs, rhs) {
    return primitiveComparator(lhs.toLowerCase(), rhs.toLowerCase());
}
function localized(localizer, useUILanguage, localizedComparator = primitiveComparator) {
    return (lhs, rhs) => localizedComparator(localizer.translate(lhs, useUILanguage), localizer.translate(rhs, true));
}
function property(propertyExtractor, propertyComparator) {
    return (lhs, rhs) => propertyComparator(propertyExtractor(lhs), propertyExtractor(rhs));
}
function optional(comparator) {
    return (lhs, rhs) => {
        if (isDefined(lhs) && !isDefined(rhs)) {
            return 1;
        }
        else if (!isDefined(lhs) && isDefined(rhs)) {
            return -1;
        }
        else {
            return comparator(lhs, rhs);
        }
    };
}
function makeChainable(comparator) {
    comparator.andThen = (next) => makeChainable(chain(comparator, next));
    return comparator;
}
function chain(current, next) {
    return (lhs, rhs) => {
        const currentComparison = current(lhs, rhs);
        if (currentComparison !== 0) {
            return currentComparison;
        }
        else {
            return next(lhs, rhs);
        }
    };
}

var comparator = /*#__PURE__*/Object.freeze({
    __proto__: null,
    reversed: reversed,
    comparingPrimitive: comparingPrimitive,
    comparingLocalizable: comparingLocalizable,
    primitiveComparator: primitiveComparator,
    stringComparatorIgnoringCase: stringComparatorIgnoringCase,
    localized: localized,
    property: property,
    optional: optional,
    makeChainable: makeChainable
});

function asLocalizable(localizations, ignoreConflicts = false) {
    const result = {};
    for (const localization of normalizeAsArray(localizations)) {
        if (localization.lang) {
            // NOTE: When ignoring conflicts keep the first value, not the last.
            if (!result.hasOwnProperty(localization.lang)) {
                result[localization.lang] = localization.value;
            }
            else if (!ignoreConflicts) {
                throw new Error('Localization already defined for language: ' + localization.lang);
            }
        }
    }
    return result;
}
function withFirstLocalizations(localizable) {
    const result = {};
    for (const [lang, value] of Object.entries(localizable)) {
        result[lang] = normalizeAsArray(value)[0];
    }
    return result;
}
function hasLocalization(localizable) {
    return !!localizable && hasValue(localizable);
}
function localizableMatches(localizable, search) {
    return anyMatching(Object.values(localizable), value => value.toLowerCase().indexOf(search.toLowerCase()) !== -1);
}

var localization = /*#__PURE__*/Object.freeze({
    __proto__: null,
    asLocalizable: asLocalizable,
    withFirstLocalizations: withFirstLocalizations,
    hasLocalization: hasLocalization,
    localizableMatches: localizableMatches
});

function getOrCreate(map, key, create) {
    const result = map.get(key);
    if (isDefined(result)) {
        return result;
    }
    else {
        const created = create();
        map.set(key, created);
        return created;
    }
}

var map = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getOrCreate: getOrCreate
});

function ignoreModalClose(err) {
    if (!isModalClose(err)) {
        throw err;
    }
    else {
        return null;
    }
}
function isModalClose(err) {
    return err === 'cancel' || err === ModalDismissReasons.BACKDROP_CLICK || err === ModalDismissReasons.ESC;
}

var modal = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ignoreModalClose: ignoreModalClose,
    isModalClose: isModalClose
});

function quoteLiteralForRegexp(literal) {
    return literal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

var regex = /*#__PURE__*/Object.freeze({
    __proto__: null,
    quoteLiteralForRegexp: quoteLiteralForRegexp
});

function matches(text, search) {
    const normalizedText = (text || '').toLowerCase();
    const normalizedSearch = (search || '').toLowerCase();
    return normalizedText.indexOf(normalizedSearch) !== -1;
}
function isNotWordCharacter(s) {
    return !!s.match(/[\s,\."]+/);
}
function rangeOrNull(s, start, end) {
    if (start === null) {
        return null;
    }
    if (s.substring(start, end).trim() !== '') {
        return { start, end };
    }
    else {
        return null;
    }
}
function wordAtOffset(s, offset) {
    let startOfWord = null;
    for (let i = 0; i < s.length; i++) {
        const lookingAt = s.charAt(i);
        if (isNotWordCharacter(lookingAt)) {
            if (i >= offset) {
                return rangeOrNull(s, startOfWord, i);
            }
            startOfWord = null;
        }
        else if (startOfWord === null) {
            startOfWord = i;
        }
    }
    return rangeOrNull(s, startOfWord, s.length);
}
const htmlEscapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
};
function escapeHtml(text) {
    return text.replace(/[&<>"']/g, function (m) { return htmlEscapeMap[m]; });
}

var string = /*#__PURE__*/Object.freeze({
    __proto__: null,
    matches: matches,
    wordAtOffset: wordAtOffset,
    escapeHtml: escapeHtml
});

function forEach(iterable, callback) {
    const iterator = iterable[Symbol.iterator]();
    for (let next = iterator.next(); next.value !== undefined; next = iterator.next()) {
        callback(next.value);
    }
}

const arrowDown = 40;
const arrowUp = 38;
const pageDown = 34;
const pageUp = 33;
const enter = 13;
const tab = 9;
const esc = 27;

function normalizeAsId(resourceName) {
    return resourceName
        .replace(/\s/g, '')
        .replace(/ö/g, 'o')
        .replace(/Ö/g, 'O')
        .replace(/ä/g, 'a')
        .replace(/Ä/g, 'A')
        .replace(/å/g, 'a')
        .replace(/Å/g, 'A');
}
function labelNameToResourceIdIdentifier(labelName) {
    return normalizeAsId(capitalizeEveryWord(labelName));
}
function capitalizeEveryWord(value) {
    return value.split(' ').map(val => val.charAt(0).toUpperCase() + val.slice(1)).join(' ');
}

function splitSearchString(search) {
    if (search) {
        const searchParts = search.split(/\s+/).filter(part => !!part);
        if (searchParts.length) {
            return searchParts;
        }
    }
    return undefined;
}
function makePrefixPostfixSearchRegexp(searchParts) {
    const expString = '^' + searchParts.map(quoteLiteralForRegexp).map(quoted => '(?=.*(?:' + quoted + '\\b|\\b' + quoted + '))').join('');
    return new RegExp(expString, 'i');
}
function makeAnywhereSearchRegexp(searchParts) {
    const expString = '^' + searchParts.map(quoteLiteralForRegexp).map(quoted => '(?=.*' + quoted + ')').join('');
    return new RegExp(expString, 'i');
}
function makeSimpleSearchRegexp(search, global = false) {
    return new RegExp(quoteLiteralForRegexp(search), global ? 'gi' : 'i');
}
function makePrefixPostfixHighlightRegexp(searchParts) {
    const expString = searchParts.sort(longestFirstComparator).map(quoteLiteralForRegexp).map(quoted => quoted + '\\b|\\b' + quoted).join('|');
    return new RegExp(expString, 'gi');
}
function makeAnywhereHighlightRegexp(searchParts) {
    const expString = searchParts.sort(longestFirstComparator).map(quoteLiteralForRegexp).join('|');
    return new RegExp(expString, 'gi');
}
/**
 * Append HTML b-tags around prefix and postfix matches of given search parts.
 * @param results the item array to process
 * @param searchParts splitted search query; if undefined then do nothing
 * @param localizableExtractor function to get label for the item
 * @param localizableSetter if defined then the extracted label will not be modified in place, but instead this method will be used to set newly created label for the item
 */
function highlightPrefixPostfixResults(results, searchParts, localizableExtractor, localizableSetter) {
    if (searchParts && searchParts.length) {
        const re = makePrefixPostfixHighlightRegexp(searchParts);
        results.forEach(item => {
            const label = localizableExtractor(item);
            const target = localizableSetter ? {} : label;
            for (let language of Object.keys(label)) {
                target[language] = label[language].replace(re, '<b>$&</b>');
            }
            if (localizableSetter) {
                localizableSetter(item, target);
            }
        });
    }
    return results;
}
function filterByPrefixPostfixSearch(items, searchParts, localizableExtractor) {
    if (searchParts && searchParts.length) {
        const re = makePrefixPostfixSearchRegexp(searchParts);
        return items.filter(item => {
            const label = localizableExtractor(item);
            for (let language of Object.keys(label)) {
                if (re.test(label[language])) {
                    return true;
                }
            }
            return false;
        });
    }
    return items.slice();
}
function longestFirstComparator(a, b) {
    const diff = b.length - a.length;
    return diff != 0 ? diff : a.localeCompare(b);
}

/**
 * Try (best effort) to fetch a value from localStorage. If a string is successfully fetched then it is returned even if it is empty.
 *
 * @param key storage key
 * @return any actual string value retrieved; or null if access failed / no value was found
 */
function getFromLocalStorageOrNull(key) {
    try {
        const value = localStorage.getItem(key);
        if (typeof value === 'string') {
            return value;
        }
    }
    catch (error) {
        console.warn('Could not use local storage: "' + error + '"');
    }
    return null;
}
/**
 * Try (best effort) to fetch a value from localStorage. If a string is successfully fetched then it is returned even if it is empty.
 *
 * @param key storage key
 * @param defaultValue default value to return if localStorage access fails or there is no value stored
 * @return any actual string value retrieved; or defaultValue if access failed / no value was found
 */
function getFromLocalStorage(key, defaultValue) {
    const fetched = getFromLocalStorageOrNull(key);
    return fetched === null ? defaultValue : fetched;
}
/**
 * Try (best effort) to store a value to localStorage.
 *
 * @param key storage key
 * @param value string value (maybe empty) to store; if undefined/null then try to remove key
 * @return true if operation seems to have succeeded; false if it quite certainly failed
 */
function setToLocalStorage(key, value) {
    try {
        if (typeof value === 'string') {
            localStorage.setItem(key, value);
        }
        else {
            localStorage.removeItem(key);
        }
        return true;
    }
    catch (error) {
        console.warn('Could not use local storage: "' + error + '"');
    }
    return false;
}

var ietfLanguageTags = [
	"af",
	"af-NA",
	"af-ZA",
	"agq",
	"agq-CM",
	"ak",
	"ak-GH",
	"am",
	"am-ET",
	"ar",
	"ar-001",
	"ar-AE",
	"ar-BH",
	"ar-DJ",
	"ar-DZ",
	"ar-EG",
	"ar-EH",
	"ar-ER",
	"ar-IL",
	"ar-IQ",
	"ar-JO",
	"ar-KM",
	"ar-KW",
	"ar-LB",
	"ar-LY",
	"ar-MA",
	"ar-MR",
	"ar-OM",
	"ar-PS",
	"ar-QA",
	"ar-SA",
	"ar-SD",
	"ar-SO",
	"ar-SS",
	"ar-SY",
	"ar-TD",
	"ar-TN",
	"ar-YE",
	"as",
	"as-IN",
	"asa",
	"asa-TZ",
	"ast",
	"ast-ES",
	"az",
	"az-Cyrl",
	"az-Cyrl-AZ",
	"az-Latn",
	"az-Latn-AZ",
	"bas",
	"bas-CM",
	"be",
	"be-BY",
	"bem",
	"bem-ZM",
	"bez",
	"bez-TZ",
	"bg",
	"bg-BG",
	"bm",
	"bm-ML",
	"bn",
	"bn-BD",
	"bn-IN",
	"bo",
	"bo-CN",
	"bo-IN",
	"br",
	"br-FR",
	"brx",
	"brx-IN",
	"bs",
	"bs-Cyrl",
	"bs-Cyrl-BA",
	"bs-Latn",
	"bs-Latn-BA",
	"ca",
	"ca-AD",
	"ca-ES",
	"ca-ES-VALENCIA",
	"ca-FR",
	"ca-IT",
	"ce",
	"ce-RU",
	"cgg",
	"cgg-UG",
	"chr",
	"chr-US",
	"ckb",
	"ckb-IQ",
	"ckb-IR",
	"cs",
	"cs-CZ",
	"cu",
	"cu-RU",
	"cy",
	"cy-GB",
	"da",
	"da-DK",
	"da-GL",
	"dav",
	"dav-KE",
	"de",
	"de-AT",
	"de-BE",
	"de-CH",
	"de-DE",
	"de-IT",
	"de-LI",
	"de-LU",
	"dje",
	"dje-NE",
	"dsb",
	"dsb-DE",
	"dua",
	"dua-CM",
	"dyo",
	"dyo-SN",
	"dz",
	"dz-BT",
	"ebu",
	"ebu-KE",
	"ee",
	"ee-GH",
	"ee-TG",
	"el",
	"el-CY",
	"el-GR",
	"en",
	"en-001",
	"en-150",
	"en-AG",
	"en-AI",
	"en-AS",
	"en-AT",
	"en-AU",
	"en-BB",
	"en-BE",
	"en-BI",
	"en-BM",
	"en-BS",
	"en-BW",
	"en-BZ",
	"en-CA",
	"en-CC",
	"en-CH",
	"en-CK",
	"en-CM",
	"en-CX",
	"en-CY",
	"en-DE",
	"en-DG",
	"en-DK",
	"en-DM",
	"en-ER",
	"en-FI",
	"en-FJ",
	"en-FK",
	"en-FM",
	"en-GB",
	"en-GD",
	"en-GG",
	"en-GH",
	"en-GI",
	"en-GM",
	"en-GU",
	"en-GY",
	"en-HK",
	"en-IE",
	"en-IL",
	"en-IM",
	"en-IN",
	"en-IO",
	"en-JE",
	"en-JM",
	"en-KE",
	"en-KI",
	"en-KN",
	"en-KY",
	"en-LC",
	"en-LR",
	"en-LS",
	"en-MG",
	"en-MH",
	"en-MO",
	"en-MP",
	"en-MS",
	"en-MT",
	"en-MU",
	"en-MW",
	"en-MY",
	"en-NA",
	"en-NF",
	"en-NG",
	"en-NL",
	"en-NR",
	"en-NU",
	"en-NZ",
	"en-PG",
	"en-PH",
	"en-PK",
	"en-PN",
	"en-PR",
	"en-PW",
	"en-RW",
	"en-SB",
	"en-SC",
	"en-SD",
	"en-SE",
	"en-SG",
	"en-SH",
	"en-SI",
	"en-SL",
	"en-SS",
	"en-SX",
	"en-SZ",
	"en-TC",
	"en-TK",
	"en-TO",
	"en-TT",
	"en-TV",
	"en-TZ",
	"en-UG",
	"en-UM",
	"en-US",
	"en-US-POSIX",
	"en-VC",
	"en-VG",
	"en-VI",
	"en-VU",
	"en-WS",
	"en-ZA",
	"en-ZM",
	"en-ZW",
	"eo",
	"eo-001",
	"es",
	"es-419",
	"es-AR",
	"es-BO",
	"es-BR",
	"es-BZ",
	"es-CL",
	"es-CO",
	"es-CR",
	"es-CU",
	"es-DO",
	"es-EA",
	"es-EC",
	"es-ES",
	"es-GQ",
	"es-GT",
	"es-HN",
	"es-IC",
	"es-MX",
	"es-NI",
	"es-PA",
	"es-PE",
	"es-PH",
	"es-PR",
	"es-PY",
	"es-SV",
	"es-US",
	"es-UY",
	"es-VE",
	"et",
	"et-EE",
	"eu",
	"eu-ES",
	"ewo",
	"ewo-CM",
	"fa",
	"fa-AF",
	"fa-IR",
	"ff",
	"ff-CM",
	"ff-GN",
	"ff-MR",
	"ff-SN",
	"fi",
	"fi-FI",
	"fil",
	"fil-PH",
	"fo",
	"fo-DK",
	"fo-FO",
	"fr",
	"fr-BE",
	"fr-BF",
	"fr-BI",
	"fr-BJ",
	"fr-BL",
	"fr-CA",
	"fr-CD",
	"fr-CF",
	"fr-CG",
	"fr-CH",
	"fr-CI",
	"fr-CM",
	"fr-DJ",
	"fr-DZ",
	"fr-FR",
	"fr-GA",
	"fr-GF",
	"fr-GN",
	"fr-GP",
	"fr-GQ",
	"fr-HT",
	"fr-KM",
	"fr-LU",
	"fr-MA",
	"fr-MC",
	"fr-MF",
	"fr-MG",
	"fr-ML",
	"fr-MQ",
	"fr-MR",
	"fr-MU",
	"fr-NC",
	"fr-NE",
	"fr-PF",
	"fr-PM",
	"fr-RE",
	"fr-RW",
	"fr-SC",
	"fr-SN",
	"fr-SY",
	"fr-TD",
	"fr-TG",
	"fr-TN",
	"fr-VU",
	"fr-WF",
	"fr-YT",
	"fur",
	"fur-IT",
	"fy",
	"fy-NL",
	"ga",
	"ga-IE",
	"gd",
	"gd-GB",
	"gl",
	"gl-ES",
	"gsw",
	"gsw-CH",
	"gsw-FR",
	"gsw-LI",
	"gu",
	"gu-IN",
	"guz",
	"guz-KE",
	"gv",
	"gv-IM",
	"ha",
	"ha-GH",
	"ha-NE",
	"ha-NG",
	"haw",
	"haw-US",
	"he",
	"he-IL",
	"hi",
	"hi-IN",
	"hr",
	"hr-BA",
	"hr-HR",
	"hsb",
	"hsb-DE",
	"hu",
	"hu-HU",
	"hy",
	"hy-AM",
	"id",
	"id-ID",
	"ig",
	"ig-NG",
	"ii",
	"ii-CN",
	"is",
	"is-IS",
	"it",
	"it-CH",
	"it-IT",
	"it-SM",
	"it-VA",
	"ja",
	"ja-JP",
	"jgo",
	"jgo-CM",
	"jmc",
	"jmc-TZ",
	"ka",
	"ka-GE",
	"kab",
	"kab-DZ",
	"kam",
	"kam-KE",
	"kde",
	"kde-TZ",
	"kea",
	"kea-CV",
	"khq",
	"khq-ML",
	"ki",
	"ki-KE",
	"kk",
	"kk-KZ",
	"kkj",
	"kkj-CM",
	"kl",
	"kl-GL",
	"kln",
	"kln-KE",
	"km",
	"km-KH",
	"kn",
	"kn-IN",
	"ko",
	"ko-KP",
	"ko-KR",
	"kok",
	"kok-IN",
	"ks",
	"ks-IN",
	"ksb",
	"ksb-TZ",
	"ksf",
	"ksf-CM",
	"ksh",
	"ksh-DE",
	"kw",
	"kw-GB",
	"ky",
	"ky-KG",
	"la",
	"lag",
	"lag-TZ",
	"lb",
	"lb-LU",
	"lg",
	"lg-UG",
	"lkt",
	"lkt-US",
	"ln",
	"ln-AO",
	"ln-CD",
	"ln-CF",
	"ln-CG",
	"lo",
	"lo-LA",
	"lrc",
	"lrc-IQ",
	"lrc-IR",
	"lt",
	"lt-LT",
	"lu",
	"lu-CD",
	"luo",
	"luo-KE",
	"luy",
	"luy-KE",
	"lv",
	"lv-LV",
	"mas",
	"mas-KE",
	"mas-TZ",
	"mer",
	"mer-KE",
	"mfe",
	"mfe-MU",
	"mg",
	"mg-MG",
	"mgh",
	"mgh-MZ",
	"mgo",
	"mgo-CM",
	"mk",
	"mk-MK",
	"ml",
	"ml-IN",
	"mn",
	"mn-MN",
	"mr",
	"mr-IN",
	"ms",
	"ms-BN",
	"ms-MY",
	"ms-SG",
	"mt",
	"mt-MT",
	"mua",
	"mua-CM",
	"my",
	"my-MM",
	"mzn",
	"mzn-IR",
	"naq",
	"naq-NA",
	"nb",
	"nb-NO",
	"nb-SJ",
	"nd",
	"nd-ZW",
	"nds",
	"nds-DE",
	"nds-NL",
	"ne",
	"ne-IN",
	"ne-NP",
	"nl",
	"nl-AW",
	"nl-BE",
	"nl-BQ",
	"nl-CW",
	"nl-NL",
	"nl-SR",
	"nl-SX",
	"nmg",
	"nmg-CM",
	"nn",
	"nn-NO",
	"nnh",
	"nnh-CM",
	"nus",
	"nus-SS",
	"nyn",
	"nyn-UG",
	"om",
	"om-ET",
	"om-KE",
	"or",
	"or-IN",
	"os",
	"os-GE",
	"os-RU",
	"pa",
	"pa-Arab",
	"pa-Arab-PK",
	"pa-Guru",
	"pa-Guru-IN",
	"pl",
	"pl-PL",
	"prg",
	"prg-001",
	"prs-AF",
	"ps",
	"ps-AF",
	"pt",
	"pt-AO",
	"pt-BR",
	"pt-CH",
	"pt-CV",
	"pt-GQ",
	"pt-GW",
	"pt-LU",
	"pt-MO",
	"pt-MZ",
	"pt-PT",
	"pt-ST",
	"pt-TL",
	"qu",
	"qu-BO",
	"qu-EC",
	"qu-PE",
	"rm",
	"rm-CH",
	"rn",
	"rn-BI",
	"ro",
	"ro-MD",
	"ro-RO",
	"rof",
	"rof-TZ",
	"root",
	"ru",
	"ru-BY",
	"ru-KG",
	"ru-KZ",
	"ru-MD",
	"ru-RU",
	"ru-UA",
	"rw",
	"rw-RW",
	"rwk",
	"rwk-TZ",
	"sah",
	"sah-RU",
	"saq",
	"saq-KE",
	"sbp",
	"sbp-TZ",
	"se",
	"se-FI",
	"se-NO",
	"se-SE",
	"seh",
	"seh-MZ",
	"ses",
	"ses-ML",
	"sg",
	"sg-CF",
	"shi",
	"shi-Latn",
	"shi-Latn-MA",
	"shi-Tfng",
	"shi-Tfng-MA",
	"si",
	"si-LK",
	"sk",
	"sk-SK",
	"sl",
	"sl-SI",
	"smn",
	"smn-FI",
	"sms",
	"sms-FI",
	"sn",
	"sn-ZW",
	"so",
	"so-DJ",
	"so-ET",
	"so-KE",
	"so-SO",
	"sq",
	"sq-AL",
	"sq-MK",
	"sq-XK",
	"sr",
	"sr-Cyrl",
	"sr-Cyrl-BA",
	"sr-Cyrl-ME",
	"sr-Cyrl-RS",
	"sr-Cyrl-XK",
	"sr-Latn",
	"sr-Latn-BA",
	"sr-Latn-ME",
	"sr-Latn-RS",
	"sr-Latn-XK",
	"sv",
	"sv-AX",
	"sv-FI",
	"sv-SE",
	"sw",
	"sw-CD",
	"sw-KE",
	"sw-TZ",
	"sw-UG",
	"ta",
	"ta-IN",
	"ta-LK",
	"ta-MY",
	"ta-SG",
	"te",
	"te-IN",
	"teo",
	"teo-KE",
	"teo-UG",
	"th",
	"th-TH",
	"ti",
	"ti-ER",
	"ti-ET",
	"tk",
	"tk-TM",
	"to",
	"to-TO",
	"tr",
	"tr-CY",
	"tr-TR",
	"twq",
	"twq-NE",
	"tzm",
	"tzm-MA",
	"ug",
	"ug-CN",
	"uk",
	"uk-UA",
	"ur",
	"ur-IN",
	"ur-PK",
	"uz",
	"uz-Arab",
	"uz-Arab-AF",
	"uz-Cyrl",
	"uz-Cyrl-UZ",
	"uz-Latn",
	"uz-Latn-UZ",
	"vai",
	"vai-Latn",
	"vai-Latn-LR",
	"vai-Vaii",
	"vai-Vaii-LR",
	"vi",
	"vi-VN",
	"vo",
	"vo-001",
	"vun",
	"vun-TZ",
	"wae",
	"wae-CH",
	"xog",
	"xog-UG",
	"yav",
	"yav-CM",
	"yi",
	"yi-001",
	"yo",
	"yo-BJ",
	"yo-NG",
	"yue",
	"yue-HK",
	"zgh",
	"zgh-MA",
	"zh",
	"zh-Hans",
	"zh-Hans-CN",
	"zh-Hans-HK",
	"zh-Hans-MO",
	"zh-Hans-SG",
	"zh-Hant",
	"zh-Hant-HK",
	"zh-Hant-MO",
	"zh-Hant-TW",
	"zu",
	"zu-ZA"
];

function requiredList(control) {
    return Object.values(control.value).length > 0 ? null : {
        required: {
            valid: false
        }
    };
}
function validateLanguage(control) {
    return contains(ietfLanguageTags, control.value) ? null : {
        validateLanguage: {
            valid: false
        }
    };
}
// TODO: The following is just an early attempt to force some structural correctness. Internationalized URLs and JavaScript's inability
//  to support unicode character classes cause so much trouble that the task is un-pleasing at best. Also, it might make sense to consider
//  disallowing userinfo, localhost and IP addresses.
const httpOrHttpsUrlRegex = /^https?:\/\/(?:[^\s\/@]+@)?(:?localhost|\[[a-fA-F0-9:.]+\]|[^\s\/@:.?#\[\]]+(?:\.[^\s\/@:.?#\[\]]+)+)(?::\d+)?(?:\/\S*)?$/;

// https://github.com/ng-bootstrap/ng-bootstrap/issues/1297
// https://github.com/ng-bootstrap/ng-bootstrap/issues/1963
// https://github.com/ng-bootstrap/ng-bootstrap/issues/643
// TODO: Deprecate when modal stack is supported by the ng-bootstrap library
class ModalService {
    constructor(modalService) {
        this.modalService = modalService;
        this.stack = [];
    }
    isModalOpen() {
        return this.stack.length > 0;
    }
    closeAllModals() {
        for (let i = this.stack.length - 1; i >= 0; i--) {
            const modalRef = this.stack[i];
            modalRef.dismiss('cancel');
        }
    }
    open(content, options) {
        const modalRef = this.modalService.open(content, options);
        this.stack.push(modalRef);
        const cleanFromStack = () => remove(this.stack, modalRef);
        modalRef.result.then(cleanFromStack, cleanFromStack);
        return modalRef;
    }
}
ModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ModalService, deps: [{ token: i1.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
ModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ModalService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ModalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.NgbModal }]; } });

const components = [
    AccordionChevronComponent,
    AjaxLoadingIndicatorComponent,
    AjaxLoadingIndicatorSmallComponent,
    BackButtonComponent,
    BreadcrumbComponent,
    ConfirmationModalComponent,
    DropdownComponent,
    ErrorModalComponent,
    ExpandableTextComponent,
    FilterDropdownComponent,
    StatusDropdownComponent,
    FooterComponent,
    HighlightPipe,
    KeysPipe,
    LoginModalComponent,
    MenuComponent,
    PopoverCloseComponent,
    TranslateValuePipe,
    RequiredSymbolComponent,
    InformationSymbolComponent,
    StatusComponent,
    IconComponent,
    ClipboardComponent,
    AlertModalComponent
];
class YtiCommonModule {
}
YtiCommonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: YtiCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
YtiCommonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: YtiCommonModule, declarations: [AccordionChevronComponent,
        AjaxLoadingIndicatorComponent,
        AjaxLoadingIndicatorSmallComponent,
        BackButtonComponent,
        BreadcrumbComponent,
        ConfirmationModalComponent,
        DropdownComponent,
        ErrorModalComponent,
        ExpandableTextComponent,
        FilterDropdownComponent,
        StatusDropdownComponent,
        FooterComponent,
        HighlightPipe,
        KeysPipe,
        LoginModalComponent,
        MenuComponent,
        PopoverCloseComponent,
        TranslateValuePipe,
        RequiredSymbolComponent,
        InformationSymbolComponent,
        StatusComponent,
        IconComponent,
        ClipboardComponent,
        AlertModalComponent], imports: [BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        TranslateModule,
        RouterModule,
        ClipboardModule], exports: [AccordionChevronComponent,
        AjaxLoadingIndicatorComponent,
        AjaxLoadingIndicatorSmallComponent,
        BackButtonComponent,
        BreadcrumbComponent,
        ConfirmationModalComponent,
        DropdownComponent,
        ErrorModalComponent,
        ExpandableTextComponent,
        FilterDropdownComponent,
        StatusDropdownComponent,
        FooterComponent,
        HighlightPipe,
        KeysPipe,
        LoginModalComponent,
        MenuComponent,
        PopoverCloseComponent,
        TranslateValuePipe,
        RequiredSymbolComponent,
        InformationSymbolComponent,
        StatusComponent,
        IconComponent,
        ClipboardComponent,
        AlertModalComponent] });
YtiCommonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: YtiCommonModule, providers: [
        ErrorModalService,
        LoginModalService,
        ConfirmationModalService,
        AlertModalService,
        UserService
    ], imports: [[
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            NgbModule,
            TranslateModule,
            RouterModule,
            ClipboardModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: YtiCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ...components
                    ],
                    exports: [
                        ...components
                    ],
                    entryComponents: [
                        ErrorModalComponent,
                        ConfirmationModalComponent,
                        LoginModalComponent,
                        AlertModalComponent
                    ],
                    imports: [
                        BrowserModule,
                        FormsModule,
                        ReactiveFormsModule,
                        NgbModule,
                        TranslateModule,
                        RouterModule,
                        ClipboardModule
                    ],
                    providers: [
                        ErrorModalService,
                        LoginModalService,
                        ConfirmationModalService,
                        AlertModalService,
                        UserService
                    ]
                }]
        }] });

/*
 * Public API Surface of yti-common-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AUTHENTICATED_USER_ENDPOINT, AccordionChevronComponent, AjaxLoadingIndicatorComponent, AjaxLoadingIndicatorSmallComponent, AlertModalComponent, AlertModalService, BackButtonComponent, BreadcrumbComponent, ClipboardComponent, ConfirmationModalComponent, ConfirmationModalService, DropdownComponent, ErrorModalComponent, ErrorModalService, ExpandableTextComponent, FilterDropdownComponent, FooterComponent, HighlightPipe, IconCategory, IconComponent, InformationSymbolComponent, KeysPipe, LOCALIZER, LoginModalComponent, LoginModalService, MenuComponent, ModalService, PopoverCloseComponent, RequiredSymbolComponent, StatusComponent, StatusDropdownComponent, TranslateValuePipe, User, UserService, YtiCommonModule, allMatching, allStatuses, allowedTargetStatuses, anyMatching, areEqual, array, arraysAreEqual, arrowDown, arrowUp, asLocalizable, assertNever, capitalizeEveryWord, changeToRestrictedStatus, collectProperties, combineResultSets, combineSets, comparator, comparingLocalizable, comparingPrimitive, contains, containsAll, containsAny, convertToMapSet, creationTimeAllowedStatuses, enter, esc, escapeHtml, filterByPrefixPostfixSearch, filterDefined, first, firstMatching, firstMatchingValue, flatten, forEach, getDataModelingMaterialIcon, getFromLocalStorage, getFromLocalStorageOrNull, getInformationDomainSvgIcon, getOrCreate, getOrCreateSet, getUiMaterialIcon, getVocabularyTypeMaterialIcon, groupBy, hasAny, hasLocalization, hasValue, highlightPrefixPostfixResults, httpOrHttpsUrlRegex, identity, ignoreModalClose, index, insertBefore, isBoolean, isDefined, isModalClose, isNumber, isString, keepMatching, labelNameToResourceIdIdentifier, last, limit, localizableMatches, localization, localized, makeAnywhereHighlightRegexp, makeAnywhereSearchRegexp, makeChainable, makePrefixPostfixHighlightRegexp, makePrefixPostfixSearchRegexp, makeSimpleSearchRegexp, map, mapOptional, matches, modal, moveElement, nextOf, nextOfMatching, normalizeAsArray, normalizeAsId, numberMapToObject, object, optional, pageDown, pageUp, previousOf, previousOfMatching, primitiveComparator, property, quoteLiteralForRegexp, referenceEquality, regex, regularStatuses, remove, removeMatching, replaceMatching, requireDefined, requireSingle, requiredList, resetWith, restrictedStatuses, reversed, selectableStatuses, set, setToLocalStorage, splitSearchString, string as str, stringComparatorIgnoringCase, stringMapToObject, swapElements, tab, validateLanguage, valuesExcludingKeys, withFirstLocalizations, wordAtOffset };
//# sourceMappingURL=vrk-yti-yti-common-ui.js.map
